var items = {
  "block.minecraft.acacia_button": "Akáciafa gomb",
  "block.minecraft.acacia_door": "Akáciafa ajtó",
  "block.minecraft.acacia_fence": "Akáciafa kerítés",
  "block.minecraft.acacia_fence_gate": "Akáciafa kerítéskapu",
  "block.minecraft.acacia_hanging_sign": "Akáciafa függőtábla",
  "block.minecraft.acacia_leaves": "Akácialevelek",
  "block.minecraft.acacia_log": "Akáciarönk",
  "block.minecraft.acacia_planks": "Akáciadeszka",
  "block.minecraft.acacia_pressure_plate": "Akáciafa nyomólap",
  "block.minecraft.acacia_sapling": "Akáciacsemete",
  "block.minecraft.acacia_shelf": "Akáciafa polc",
  "block.minecraft.acacia_sign": "Akáciafa tábla",
  "block.minecraft.acacia_slab": "Akáciafa lap",
  "block.minecraft.acacia_stairs": "Akáciafa lépcső",
  "block.minecraft.acacia_trapdoor": "Akáciafa csapóajtó",
  "block.minecraft.acacia_wall_hanging_sign": "Akáciafa fali függőtábla",
  "block.minecraft.acacia_wall_sign": "Akáciafa falitábla",
  "block.minecraft.acacia_wood": "Akáciablokk",
  "block.minecraft.activator_rail": "Aktiválósín",
  "block.minecraft.air": "Levegő",
  "block.minecraft.allium": "Hagymavirág",
  "block.minecraft.amethyst_block": "Ametisztblokk",
  "block.minecraft.amethyst_cluster": "Ametiszt-kristálycsoport",
  "block.minecraft.ancient_debris": "Ősi törmelék",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitlap",
  "block.minecraft.andesite_stairs": "Andezitlépcső",
  "block.minecraft.andesite_wall": "Andezitfal",
  "block.minecraft.anvil": "Üllő",
  "block.minecraft.attached_melon_stem": "Csatlakozott dinnyeszár",
  "block.minecraft.attached_pumpkin_stem": "Csatlakozott tökszár",
  "block.minecraft.azalea": "Azálea",
  "block.minecraft.azalea_leaves": "Azálealevelek",
  "block.minecraft.azure_bluet": "Kékpárna",
  "block.minecraft.bamboo": "Bambusz",
  "block.minecraft.bamboo_block": "Bambuszblokk",
  "block.minecraft.bamboo_button": "Bambuszgomb",
  "block.minecraft.bamboo_door": "Bambuszajtó",
  "block.minecraft.bamboo_fence": "Bambuszkerítés",
  "block.minecraft.bamboo_fence_gate": "Bambusz kerítéskapu",
  "block.minecraft.bamboo_hanging_sign": "Bambusz függőtábla",
  "block.minecraft.bamboo_mosaic": "Bambuszmozaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambuszmozaik-lap",
  "block.minecraft.bamboo_mosaic_stairs": "Bambuszmozaik-lépcső",
  "block.minecraft.bamboo_planks": "Bambuszdeszka",
  "block.minecraft.bamboo_pressure_plate": "Bambusz nyomólap",
  "block.minecraft.bamboo_sapling": "Bambuszhajtás",
  "block.minecraft.bamboo_shelf": "Bambuszpolc",
  "block.minecraft.bamboo_sign": "Bambusztábla",
  "block.minecraft.bamboo_slab": "Bambuszlap",
  "block.minecraft.bamboo_stairs": "Bambuszlépcső",
  "block.minecraft.bamboo_trapdoor": "Bambusz csapóajtó",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusz fali függőtábla",
  "block.minecraft.bamboo_wall_sign": "Bambusz falitábla",
  "block.minecraft.banner.base.black": "Teljesen fekete mező",
  "block.minecraft.banner.base.blue": "Teljesen kék mező",
  "block.minecraft.banner.base.brown": "Teljesen barna mező",
  "block.minecraft.banner.base.cyan": "Teljesen türkiz mező",
  "block.minecraft.banner.base.gray": "Teljesen szürke mező",
  "block.minecraft.banner.base.green": "Teljesen zöld mező",
  "block.minecraft.banner.base.light_blue": "Teljesen világoskék mező",
  "block.minecraft.banner.base.light_gray": "Teljesen világosszürke mező",
  "block.minecraft.banner.base.lime": "Teljesen világoszöld mező",
  "block.minecraft.banner.base.magenta": "Teljesen bíbor mező",
  "block.minecraft.banner.base.orange": "Teljesen narancssárga mező",
  "block.minecraft.banner.base.pink": "Teljesen rózsaszín mező",
  "block.minecraft.banner.base.purple": "Teljesen lila mező",
  "block.minecraft.banner.base.red": "Teljesen vörös mező",
  "block.minecraft.banner.base.white": "Teljesen fehér mező",
  "block.minecraft.banner.base.yellow": "Teljesen sárga mező",
  "block.minecraft.banner.border.black": "Fekete ráma",
  "block.minecraft.banner.border.blue": "Kék ráma",
  "block.minecraft.banner.border.brown": "Barna ráma",
  "block.minecraft.banner.border.cyan": "Türkizkék ráma",
  "block.minecraft.banner.border.gray": "Szürke ráma",
  "block.minecraft.banner.border.green": "Zöld ráma",
  "block.minecraft.banner.border.light_blue": "Világoskék ráma",
  "block.minecraft.banner.border.light_gray": "Világosszürke ráma",
  "block.minecraft.banner.border.lime": "Világoszöld ráma",
  "block.minecraft.banner.border.magenta": "Bíbor ráma",
  "block.minecraft.banner.border.orange": "Narancssárga ráma",
  "block.minecraft.banner.border.pink": "Rózsaszín ráma",
  "block.minecraft.banner.border.purple": "Lila ráma",
  "block.minecraft.banner.border.red": "Vörös ráma",
  "block.minecraft.banner.border.white": "Fehér ráma",
  "block.minecraft.banner.border.yellow": "Sárga ráma",
  "block.minecraft.banner.bricks.black": "Fekete téglaminta",
  "block.minecraft.banner.bricks.blue": "Kék téglaminta",
  "block.minecraft.banner.bricks.brown": "Barna téglaminta",
  "block.minecraft.banner.bricks.cyan": "Türkizkék téglaminta",
  "block.minecraft.banner.bricks.gray": "Szürke téglaminta",
  "block.minecraft.banner.bricks.green": "Zöld téglaminta",
  "block.minecraft.banner.bricks.light_blue": "Világoskék téglaminta",
  "block.minecraft.banner.bricks.light_gray": "Világosszürke téglaminta",
  "block.minecraft.banner.bricks.lime": "Világoszöld téglaminta",
  "block.minecraft.banner.bricks.magenta": "Bíbor téglaminta",
  "block.minecraft.banner.bricks.orange": "Narancssárga téglaminta",
  "block.minecraft.banner.bricks.pink": "Rózsaszín téglaminta",
  "block.minecraft.banner.bricks.purple": "Lila téglaminta",
  "block.minecraft.banner.bricks.red": "Vörös téglaminta",
  "block.minecraft.banner.bricks.white": "Fehér téglaminta",
  "block.minecraft.banner.bricks.yellow": "Sárga téglaminta",
  "block.minecraft.banner.circle.black": "Fekete lepényes",
  "block.minecraft.banner.circle.blue": "Kék lepényes",
  "block.minecraft.banner.circle.brown": "Barna lepényes",
  "block.minecraft.banner.circle.cyan": "Türkizkék lepényes",
  "block.minecraft.banner.circle.gray": "Szürke lepényes",
  "block.minecraft.banner.circle.green": "Zöld lepényes",
  "block.minecraft.banner.circle.light_blue": "Világoskék lepényes",
  "block.minecraft.banner.circle.light_gray": "Világosszürke lepényes",
  "block.minecraft.banner.circle.lime": "Világoszöld lepényes",
  "block.minecraft.banner.circle.magenta": "Bíbor lepényes",
  "block.minecraft.banner.circle.orange": "Narancssárga lepényes",
  "block.minecraft.banner.circle.pink": "Rózsaszín lepényes",
  "block.minecraft.banner.circle.purple": "Lila lepényes",
  "block.minecraft.banner.circle.red": "Vörös lepényes",
  "block.minecraft.banner.circle.white": "Fehér lepényes",
  "block.minecraft.banner.circle.yellow": "Sárga lepényes",
  "block.minecraft.banner.creeper.black": "Fekete creeper címerkép",
  "block.minecraft.banner.creeper.blue": "Kék creeper címerkép",
  "block.minecraft.banner.creeper.brown": "Barna creeper címerkép",
  "block.minecraft.banner.creeper.cyan": "Türkizkék creeper címerkép",
  "block.minecraft.banner.creeper.gray": "Szürke creeper címerkép",
  "block.minecraft.banner.creeper.green": "Zöld creeper címerkép",
  "block.minecraft.banner.creeper.light_blue": "Világoskék creeper címerkép",
  "block.minecraft.banner.creeper.light_gray": "Világosszürke creeper címerkép",
  "block.minecraft.banner.creeper.lime": "Világoszöld creeper címerkép",
  "block.minecraft.banner.creeper.magenta": "Bíbor creeper címerkép",
  "block.minecraft.banner.creeper.orange": "Narancssárga creeper címerkép",
  "block.minecraft.banner.creeper.pink": "Rózsaszín creeper címerkép",
  "block.minecraft.banner.creeper.purple": "Lila creeper címerkép",
  "block.minecraft.banner.creeper.red": "Vörös creeper címerkép",
  "block.minecraft.banner.creeper.white": "Fehér creeper címerkép",
  "block.minecraft.banner.creeper.yellow": "Sárga creeper címerkép",
  "block.minecraft.banner.cross.black": "Fekete harántkereszt",
  "block.minecraft.banner.cross.blue": "Kék harántkereszt",
  "block.minecraft.banner.cross.brown": "Barna harántkereszt",
  "block.minecraft.banner.cross.cyan": "Türkizkék harántkereszt",
  "block.minecraft.banner.cross.gray": "Szürke harántkereszt",
  "block.minecraft.banner.cross.green": "Zöld harántkereszt",
  "block.minecraft.banner.cross.light_blue": "Világoskék harántkereszt",
  "block.minecraft.banner.cross.light_gray": "Világosszürke harántkereszt",
  "block.minecraft.banner.cross.lime": "Világoszöld harántkereszt",
  "block.minecraft.banner.cross.magenta": "Bíbor harántkereszt",
  "block.minecraft.banner.cross.orange": "Narancssárga harántkereszt",
  "block.minecraft.banner.cross.pink": "Rózsaszín harántkereszt",
  "block.minecraft.banner.cross.purple": "Lila harántkereszt",
  "block.minecraft.banner.cross.red": "Vörös harántkereszt",
  "block.minecraft.banner.cross.white": "Fehér harántkereszt",
  "block.minecraft.banner.cross.yellow": "Sárga harántkereszt",
  "block.minecraft.banner.curly_border.black": "Fekete fogas ráma",
  "block.minecraft.banner.curly_border.blue": "Kék fogas ráma",
  "block.minecraft.banner.curly_border.brown": "Barna fogas ráma",
  "block.minecraft.banner.curly_border.cyan": "Türkizkék fogas ráma",
  "block.minecraft.banner.curly_border.gray": "Szürke fogas ráma",
  "block.minecraft.banner.curly_border.green": "Zöld fogas ráma",
  "block.minecraft.banner.curly_border.light_blue": "Világoskék fogas ráma",
  "block.minecraft.banner.curly_border.light_gray": "Világosszürke fogas ráma",
  "block.minecraft.banner.curly_border.lime": "Világoszöld fogas ráma",
  "block.minecraft.banner.curly_border.magenta": "Bíbor fogas ráma",
  "block.minecraft.banner.curly_border.orange": "Narancssárga fogas ráma",
  "block.minecraft.banner.curly_border.pink": "Rózsaszín fogas ráma",
  "block.minecraft.banner.curly_border.purple": "Lila fogas ráma",
  "block.minecraft.banner.curly_border.red": "Vörös fogas ráma",
  "block.minecraft.banner.curly_border.white": "Fehér fogas ráma",
  "block.minecraft.banner.curly_border.yellow": "Sárga fogas ráma",
  "block.minecraft.banner.diagonal_left.black": "Feketével balharántolt",
  "block.minecraft.banner.diagonal_left.blue": "Kékkel balharántolt",
  "block.minecraft.banner.diagonal_left.brown": "Barnával balharántolt",
  "block.minecraft.banner.diagonal_left.cyan": "Türkizkékkel balharántolt",
  "block.minecraft.banner.diagonal_left.gray": "Szürkével balharántolt",
  "block.minecraft.banner.diagonal_left.green": "Zölddel balharántolt",
  "block.minecraft.banner.diagonal_left.light_blue": "Világoskékkel balharántolt",
  "block.minecraft.banner.diagonal_left.light_gray": "Világosszürkével balharántolt",
  "block.minecraft.banner.diagonal_left.lime": "Világoszölddel balharántolt",
  "block.minecraft.banner.diagonal_left.magenta": "Bíborral balharántolt",
  "block.minecraft.banner.diagonal_left.orange": "Narancssárgával balharántolt",
  "block.minecraft.banner.diagonal_left.pink": "Rózsaszínnel balharántolt",
  "block.minecraft.banner.diagonal_left.purple": "Lilával balharántolt",
  "block.minecraft.banner.diagonal_left.red": "Vörössel balharántolt",
  "block.minecraft.banner.diagonal_left.white": "Fehérrel balharántolt",
  "block.minecraft.banner.diagonal_left.yellow": "Sárgával balharántolt",
  "block.minecraft.banner.diagonal_right.black": "Feketével harántolt",
  "block.minecraft.banner.diagonal_right.blue": "Kékkel harántolt",
  "block.minecraft.banner.diagonal_right.brown": "Barnával harántolt",
  "block.minecraft.banner.diagonal_right.cyan": "Türkizkékkel harántolt",
  "block.minecraft.banner.diagonal_right.gray": "Szürkével harántolt",
  "block.minecraft.banner.diagonal_right.green": "Zölddel harántolt",
  "block.minecraft.banner.diagonal_right.light_blue": "Világoskékkel harántolt",
  "block.minecraft.banner.diagonal_right.light_gray": "Világosszürkével harántolt",
  "block.minecraft.banner.diagonal_right.lime": "Világoszölddel harántolt",
  "block.minecraft.banner.diagonal_right.magenta": "Bíborral harántolt",
  "block.minecraft.banner.diagonal_right.orange": "Narancssárgával harántolt",
  "block.minecraft.banner.diagonal_right.pink": "Rózsaszínnel harántolt",
  "block.minecraft.banner.diagonal_right.purple": "Lilával harántolt",
  "block.minecraft.banner.diagonal_right.red": "Vörössel harántolt",
  "block.minecraft.banner.diagonal_right.white": "Fehérrel harántolt",
  "block.minecraft.banner.diagonal_right.yellow": "Sárgával harántolt",
  "block.minecraft.banner.diagonal_up_left.black": "Feketével alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.blue": "Kékkel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.brown": "Barnával alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.cyan": "Türkizkékkel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.gray": "Szürkével alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.green": "Zölddel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Világoskékkel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Világosszürkével alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.lime": "Világoszölddel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.magenta": "Bíborral alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.orange": "Narancssárgával alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.pink": "Rózsaszínnel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilával alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.red": "Vörössel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.white": "Fehérrel alulról harántolt",
  "block.minecraft.banner.diagonal_up_left.yellow": "Sárgával alulról harántolt",
  "block.minecraft.banner.diagonal_up_right.black": "Feketével alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.blue": "Kékkel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.brown": "Barnával alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.cyan": "Türkizkékkel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.gray": "Szürkével alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.green": "Zölddel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Világoskékkel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Világosszürkével alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.lime": "Világoszölddel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.magenta": "Bíborral alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.orange": "Narancssárgával alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.pink": "Rózsaszínnel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilával alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.red": "Vörössel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.white": "Fehérrel alulról balharántolt",
  "block.minecraft.banner.diagonal_up_right.yellow": "Sárgával alulról balharántolt",
  "block.minecraft.banner.flow.black": "Fekete örvény",
  "block.minecraft.banner.flow.blue": "Kék örvény",
  "block.minecraft.banner.flow.brown": "Barna örvény",
  "block.minecraft.banner.flow.cyan": "Türkizkék örvény",
  "block.minecraft.banner.flow.gray": "Szürke örvény",
  "block.minecraft.banner.flow.green": "Zöld örvény",
  "block.minecraft.banner.flow.light_blue": "Világoskék örvény",
  "block.minecraft.banner.flow.light_gray": "Világosszürke örvény",
  "block.minecraft.banner.flow.lime": "Világoszöld örvény",
  "block.minecraft.banner.flow.magenta": "Bíbor örvény",
  "block.minecraft.banner.flow.orange": "Narancssárga örvény",
  "block.minecraft.banner.flow.pink": "Rózsaszín örvény",
  "block.minecraft.banner.flow.purple": "Lila örvény",
  "block.minecraft.banner.flow.red": "Vörös örvény",
  "block.minecraft.banner.flow.white": "Fehér örvény",
  "block.minecraft.banner.flow.yellow": "Sárga örvény",
  "block.minecraft.banner.flower.black": "Fekete virág címerkép",
  "block.minecraft.banner.flower.blue": "Kék virág címerkép",
  "block.minecraft.banner.flower.brown": "Barna virág címerkép",
  "block.minecraft.banner.flower.cyan": "Türkizkék virág címerkép",
  "block.minecraft.banner.flower.gray": "Szürke virág címerkép",
  "block.minecraft.banner.flower.green": "Zöld virág címerkép",
  "block.minecraft.banner.flower.light_blue": "Világoskék virág címerkép",
  "block.minecraft.banner.flower.light_gray": "Világosszürke virág címerkép",
  "block.minecraft.banner.flower.lime": "Világoszöld virág címerkép",
  "block.minecraft.banner.flower.magenta": "Bíbor virág címerkép",
  "block.minecraft.banner.flower.orange": "Narancssárga virág címerkép",
  "block.minecraft.banner.flower.pink": "Rózsaszín virág címerkép",
  "block.minecraft.banner.flower.purple": "Lila virág címerkép",
  "block.minecraft.banner.flower.red": "Vörös virág címerkép",
  "block.minecraft.banner.flower.white": "Fehér virág címerkép",
  "block.minecraft.banner.flower.yellow": "Sárga virág címerkép",
  "block.minecraft.banner.globe.black": "Fekete földgömb",
  "block.minecraft.banner.globe.blue": "Kék földgömb",
  "block.minecraft.banner.globe.brown": "Barna földgömb",
  "block.minecraft.banner.globe.cyan": "Türkizkék földgömb",
  "block.minecraft.banner.globe.gray": "Szürke földgömb",
  "block.minecraft.banner.globe.green": "Zöld földgömb",
  "block.minecraft.banner.globe.light_blue": "Világoskék földgömb",
  "block.minecraft.banner.globe.light_gray": "Világosszürke földgömb",
  "block.minecraft.banner.globe.lime": "Világoszöld földgömb",
  "block.minecraft.banner.globe.magenta": "Bíbor földgömb",
  "block.minecraft.banner.globe.orange": "Narancssárga földgömb",
  "block.minecraft.banner.globe.pink": "Rózsaszín földgömb",
  "block.minecraft.banner.globe.purple": "Lila földgömb",
  "block.minecraft.banner.globe.red": "Vörös földgömb",
  "block.minecraft.banner.globe.white": "Fehér földgömb",
  "block.minecraft.banner.globe.yellow": "Sárga földgömb",
  "block.minecraft.banner.gradient.black": "Fekete színátmenet",
  "block.minecraft.banner.gradient.blue": "Kék színátmenet",
  "block.minecraft.banner.gradient.brown": "Barna színátmenet",
  "block.minecraft.banner.gradient.cyan": "Türkizkék színátmenet",
  "block.minecraft.banner.gradient.gray": "Szürke színátmenet",
  "block.minecraft.banner.gradient.green": "Zöld színátmenet",
  "block.minecraft.banner.gradient.light_blue": "Világoskék színátmenet",
  "block.minecraft.banner.gradient.light_gray": "Világosszürke színátmenet",
  "block.minecraft.banner.gradient.lime": "Világoszöld színátmenet",
  "block.minecraft.banner.gradient.magenta": "Bíbor színátmenet",
  "block.minecraft.banner.gradient.orange": "Narancssárga színátmenet",
  "block.minecraft.banner.gradient.pink": "Rózsaszín színátmenet",
  "block.minecraft.banner.gradient.purple": "Lila színátmenet",
  "block.minecraft.banner.gradient.red": "Vörös színátmenet",
  "block.minecraft.banner.gradient.white": "Fehér színátmenet",
  "block.minecraft.banner.gradient.yellow": "Sárga színátmenet",
  "block.minecraft.banner.gradient_up.black": "Fekete színátmenet alulról",
  "block.minecraft.banner.gradient_up.blue": "Kék színátmenet alulról",
  "block.minecraft.banner.gradient_up.brown": "Barna színátmenet alulról",
  "block.minecraft.banner.gradient_up.cyan": "Türkizkék színátmenet alulról",
  "block.minecraft.banner.gradient_up.gray": "Szürke színátmenet alulról",
  "block.minecraft.banner.gradient_up.green": "Zöld színátmenet alulról",
  "block.minecraft.banner.gradient_up.light_blue": "Világoskék színátmenet alulról",
  "block.minecraft.banner.gradient_up.light_gray": "Világosszürke színátmenet alulról",
  "block.minecraft.banner.gradient_up.lime": "Világoszöld színátmenet alulról",
  "block.minecraft.banner.gradient_up.magenta": "Bíbor színátmenet alulról",
  "block.minecraft.banner.gradient_up.orange": "Narancssárga színátmenet alulról",
  "block.minecraft.banner.gradient_up.pink": "Rózsaszín színátmenet alulról",
  "block.minecraft.banner.gradient_up.purple": "Lila színátmenet alulról",
  "block.minecraft.banner.gradient_up.red": "Vörös színátmenet alulról",
  "block.minecraft.banner.gradient_up.white": "Fehér színátmenet alulról",
  "block.minecraft.banner.gradient_up.yellow": "Sárga színátmenet alulról",
  "block.minecraft.banner.guster.black": "Fekete széllökő",
  "block.minecraft.banner.guster.blue": "Kék széllökő",
  "block.minecraft.banner.guster.brown": "Barna széllökő",
  "block.minecraft.banner.guster.cyan": "Türkizkék széllökő",
  "block.minecraft.banner.guster.gray": "Szürke széllökő",
  "block.minecraft.banner.guster.green": "Zöld széllökő",
  "block.minecraft.banner.guster.light_blue": "Világoskék széllökő",
  "block.minecraft.banner.guster.light_gray": "Világosszürke széllökő",
  "block.minecraft.banner.guster.lime": "Világoszöld széllökő",
  "block.minecraft.banner.guster.magenta": "Bíbor széllökő",
  "block.minecraft.banner.guster.orange": "Narancssárga széllökő",
  "block.minecraft.banner.guster.pink": "Rózsaszín széllökő",
  "block.minecraft.banner.guster.purple": "Lila széllökő",
  "block.minecraft.banner.guster.red": "Vörös széllökő",
  "block.minecraft.banner.guster.white": "Fehér széllökő",
  "block.minecraft.banner.guster.yellow": "Sárga széllökő",
  "block.minecraft.banner.half_horizontal.black": "Feketével vágott",
  "block.minecraft.banner.half_horizontal.blue": "Kékkel vágott",
  "block.minecraft.banner.half_horizontal.brown": "Barnával vágott",
  "block.minecraft.banner.half_horizontal.cyan": "Türkizkékkel vágott",
  "block.minecraft.banner.half_horizontal.gray": "Szürkével vágott",
  "block.minecraft.banner.half_horizontal.green": "Zölddel vágott",
  "block.minecraft.banner.half_horizontal.light_blue": "Világoskékkel vágott",
  "block.minecraft.banner.half_horizontal.light_gray": "Világosszürkével vágott",
  "block.minecraft.banner.half_horizontal.lime": "Világoszölddel vágott",
  "block.minecraft.banner.half_horizontal.magenta": "Bíborral vágott",
  "block.minecraft.banner.half_horizontal.orange": "Narancssárgával vágott",
  "block.minecraft.banner.half_horizontal.pink": "Rózsaszínnel vágott",
  "block.minecraft.banner.half_horizontal.purple": "Lilával vágott",
  "block.minecraft.banner.half_horizontal.red": "Vörössel vágott",
  "block.minecraft.banner.half_horizontal.white": "Fehérrel vágott",
  "block.minecraft.banner.half_horizontal.yellow": "Sárgával vágott",
  "block.minecraft.banner.half_horizontal_bottom.black": "Feketével alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Kékkel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Barnával alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Türkizkékkel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Szürkével alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zölddel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Világoskékkel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Világosszürkével alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Világoszölddel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Bíborral alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Narancssárgával alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rózsaszínnel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilával alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.red": "Vörössel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.white": "Fehérrel alulról vágott",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Sárgával alulról vágott",
  "block.minecraft.banner.half_vertical.black": "Feketével hasított",
  "block.minecraft.banner.half_vertical.blue": "Kékkel hasított",
  "block.minecraft.banner.half_vertical.brown": "Barnával hasított",
  "block.minecraft.banner.half_vertical.cyan": "Türkizkékkel hasított",
  "block.minecraft.banner.half_vertical.gray": "Szürkével hasított",
  "block.minecraft.banner.half_vertical.green": "Zölddel hasított",
  "block.minecraft.banner.half_vertical.light_blue": "Világoskékkel hasított",
  "block.minecraft.banner.half_vertical.light_gray": "Világosszürkével hasított",
  "block.minecraft.banner.half_vertical.lime": "Világoszölddel hasított",
  "block.minecraft.banner.half_vertical.magenta": "Bíborral hasított",
  "block.minecraft.banner.half_vertical.orange": "Narancssárgával hasított",
  "block.minecraft.banner.half_vertical.pink": "Rózsaszínnel hasított",
  "block.minecraft.banner.half_vertical.purple": "Lilával hasított",
  "block.minecraft.banner.half_vertical.red": "Vörössel hasított",
  "block.minecraft.banner.half_vertical.white": "Fehérrel hasított",
  "block.minecraft.banner.half_vertical.yellow": "Sárgával hasított",
  "block.minecraft.banner.half_vertical_right.black": "Feketével balról hasított",
  "block.minecraft.banner.half_vertical_right.blue": "Kékkel balról hasított",
  "block.minecraft.banner.half_vertical_right.brown": "Barnával balról hasított",
  "block.minecraft.banner.half_vertical_right.cyan": "Türkizkékkel balról hasított",
  "block.minecraft.banner.half_vertical_right.gray": "Szürkével balról hasított",
  "block.minecraft.banner.half_vertical_right.green": "Zölddel balról hasított",
  "block.minecraft.banner.half_vertical_right.light_blue": "Világoskékkel balról hasított",
  "block.minecraft.banner.half_vertical_right.light_gray": "Világosszürkével balról hasított",
  "block.minecraft.banner.half_vertical_right.lime": "Világoszölddel balról hasított",
  "block.minecraft.banner.half_vertical_right.magenta": "Bíborral balról hasított",
  "block.minecraft.banner.half_vertical_right.orange": "Narancssárgával balról hasított",
  "block.minecraft.banner.half_vertical_right.pink": "Rózsaszínnel balról hasított",
  "block.minecraft.banner.half_vertical_right.purple": "Lilával balról hasított",
  "block.minecraft.banner.half_vertical_right.red": "Vörössel balról hasított",
  "block.minecraft.banner.half_vertical_right.white": "Fehérrel balról hasított",
  "block.minecraft.banner.half_vertical_right.yellow": "Sárgával balról hasított",
  "block.minecraft.banner.mojang.black": "Fekete Mojang címerkép",
  "block.minecraft.banner.mojang.blue": "Kék Mojang címerkép",
  "block.minecraft.banner.mojang.brown": "Barna Mojang címerkép",
  "block.minecraft.banner.mojang.cyan": "Türkizkék Mojang címerkép",
  "block.minecraft.banner.mojang.gray": "Szürke Mojang címerkép",
  "block.minecraft.banner.mojang.green": "Zöld Mojang címerkép",
  "block.minecraft.banner.mojang.light_blue": "Világoskék Mojang címerkép",
  "block.minecraft.banner.mojang.light_gray": "Világosszürke Mojang címerkép",
  "block.minecraft.banner.mojang.lime": "Világoszöld Mojang címerkép",
  "block.minecraft.banner.mojang.magenta": "Bíbor Mojang címerkép",
  "block.minecraft.banner.mojang.orange": "Narancssárga Mojang címerkép",
  "block.minecraft.banner.mojang.pink": "Rózsaszín Mojang címerkép",
  "block.minecraft.banner.mojang.purple": "Lila Mojang címerkép",
  "block.minecraft.banner.mojang.red": "Vörös Mojang címerkép",
  "block.minecraft.banner.mojang.white": "Fehér Mojang címerkép",
  "block.minecraft.banner.mojang.yellow": "Sárga Mojang címerkép",
  "block.minecraft.banner.piglin.black": "Fekete disznóorr",
  "block.minecraft.banner.piglin.blue": "Kék disznóorr",
  "block.minecraft.banner.piglin.brown": "Barna disznóorr",
  "block.minecraft.banner.piglin.cyan": "Cián disznóorr",
  "block.minecraft.banner.piglin.gray": "Szürke disznóorr",
  "block.minecraft.banner.piglin.green": "Zöld disznóorr",
  "block.minecraft.banner.piglin.light_blue": "Világoskék disznóorr",
  "block.minecraft.banner.piglin.light_gray": "Világosszürke disznóorr",
  "block.minecraft.banner.piglin.lime": "Világoszöld disznóorr",
  "block.minecraft.banner.piglin.magenta": "Bíbor disznóorr",
  "block.minecraft.banner.piglin.orange": "Narancssárga disznóorr",
  "block.minecraft.banner.piglin.pink": "Rózsaszín disznóorr",
  "block.minecraft.banner.piglin.purple": "Lila disznóorr",
  "block.minecraft.banner.piglin.red": "Vörös disznóorr",
  "block.minecraft.banner.piglin.white": "Fehér disznóorr",
  "block.minecraft.banner.piglin.yellow": "Sárga disznóorr",
  "block.minecraft.banner.rhombus.black": "Fekete nagyruta",
  "block.minecraft.banner.rhombus.blue": "Kék nagyruta",
  "block.minecraft.banner.rhombus.brown": "Barna nagyruta",
  "block.minecraft.banner.rhombus.cyan": "Türkizkék nagyruta",
  "block.minecraft.banner.rhombus.gray": "Szürke nagyruta",
  "block.minecraft.banner.rhombus.green": "Zöld nagyruta",
  "block.minecraft.banner.rhombus.light_blue": "Világoskék nagyruta",
  "block.minecraft.banner.rhombus.light_gray": "Világosszürke nagyruta",
  "block.minecraft.banner.rhombus.lime": "Világoszöld nagyruta",
  "block.minecraft.banner.rhombus.magenta": "Bíbor nagyruta",
  "block.minecraft.banner.rhombus.orange": "Narancssárga nagyruta",
  "block.minecraft.banner.rhombus.pink": "Rózsaszín nagyruta",
  "block.minecraft.banner.rhombus.purple": "Lila nagyruta",
  "block.minecraft.banner.rhombus.red": "Vörös nagyruta",
  "block.minecraft.banner.rhombus.white": "Fehér nagyruta",
  "block.minecraft.banner.rhombus.yellow": "Sárga nagyruta",
  "block.minecraft.banner.skull.black": "Fekete koponya címerkép",
  "block.minecraft.banner.skull.blue": "Kék koponya címerkép",
  "block.minecraft.banner.skull.brown": "Barna koponya címerkép",
  "block.minecraft.banner.skull.cyan": "Türkizkék koponya címerkép",
  "block.minecraft.banner.skull.gray": "Szürke koponya címerkép",
  "block.minecraft.banner.skull.green": "Zöld koponya címerkép",
  "block.minecraft.banner.skull.light_blue": "Világoskék koponya címerkép",
  "block.minecraft.banner.skull.light_gray": "Világosszürke koponya címerkép",
  "block.minecraft.banner.skull.lime": "Világoszöld koponya címerkép",
  "block.minecraft.banner.skull.magenta": "Bíbor koponya címerkép",
  "block.minecraft.banner.skull.orange": "Narancssárga koponya címerkép",
  "block.minecraft.banner.skull.pink": "Rózsaszín koponya címerkép",
  "block.minecraft.banner.skull.purple": "Lila koponya címerkép",
  "block.minecraft.banner.skull.red": "Vörös koponya címerkép",
  "block.minecraft.banner.skull.white": "Fehér koponya címerkép",
  "block.minecraft.banner.skull.yellow": "Sárga koponya címerkép",
  "block.minecraft.banner.small_stripes.black": "Feketével cölöpölt",
  "block.minecraft.banner.small_stripes.blue": "Kékkel cölöpölt",
  "block.minecraft.banner.small_stripes.brown": "Barnával cölöpölt",
  "block.minecraft.banner.small_stripes.cyan": "Türkizkékkel cölöpölt",
  "block.minecraft.banner.small_stripes.gray": "Szürkével cölöpölt",
  "block.minecraft.banner.small_stripes.green": "Zölddel cölöpölt",
  "block.minecraft.banner.small_stripes.light_blue": "Világoskékkel cölöpölt",
  "block.minecraft.banner.small_stripes.light_gray": "Világosszürkével cölöpölt",
  "block.minecraft.banner.small_stripes.lime": "Világoszölddel cölöpölt",
  "block.minecraft.banner.small_stripes.magenta": "Bíborral cölöpölt",
  "block.minecraft.banner.small_stripes.orange": "Narancssárgával cölöpölt",
  "block.minecraft.banner.small_stripes.pink": "Rózsaszínnel cölöpölt",
  "block.minecraft.banner.small_stripes.purple": "Lilával cölöpölt",
  "block.minecraft.banner.small_stripes.red": "Vörössel cölöpölt",
  "block.minecraft.banner.small_stripes.white": "Fehérrel cölöpölt",
  "block.minecraft.banner.small_stripes.yellow": "Sárgával cölöpölt",
  "block.minecraft.banner.square_bottom_left.black": "Fekete alsótelek",
  "block.minecraft.banner.square_bottom_left.blue": "Kék alsótelek",
  "block.minecraft.banner.square_bottom_left.brown": "Barna alsótelek",
  "block.minecraft.banner.square_bottom_left.cyan": "Türkizkék alsótelek",
  "block.minecraft.banner.square_bottom_left.gray": "Szürke alsótelek",
  "block.minecraft.banner.square_bottom_left.green": "Zöld alsótelek",
  "block.minecraft.banner.square_bottom_left.light_blue": "Világoskék alsótelek",
  "block.minecraft.banner.square_bottom_left.light_gray": "Világosszürke alsótelek",
  "block.minecraft.banner.square_bottom_left.lime": "Világoszöld alsótelek",
  "block.minecraft.banner.square_bottom_left.magenta": "Bíbor alsótelek",
  "block.minecraft.banner.square_bottom_left.orange": "Narancssárga alsótelek",
  "block.minecraft.banner.square_bottom_left.pink": "Rózsaszín alsótelek",
  "block.minecraft.banner.square_bottom_left.purple": "Lila alsótelek",
  "block.minecraft.banner.square_bottom_left.red": "Vörös alsótelek",
  "block.minecraft.banner.square_bottom_left.white": "Fehér alsótelek",
  "block.minecraft.banner.square_bottom_left.yellow": "Sárga alsótelek",
  "block.minecraft.banner.square_bottom_right.black": "Fekete bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.blue": "Kék bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.brown": "Barna bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.cyan": "Türkizkék bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.gray": "Szürke bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.green": "Zöld bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.light_blue": "Világoskék bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.light_gray": "Világosszürke bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.lime": "Világoszöld bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.magenta": "Bíbor bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.orange": "Narancssárga bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.pink": "Rózsaszín bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.purple": "Lila bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.red": "Vörös bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.white": "Fehér bal-alsótelek",
  "block.minecraft.banner.square_bottom_right.yellow": "Sárga bal-alsótelek",
  "block.minecraft.banner.square_top_left.black": "Fekete telek",
  "block.minecraft.banner.square_top_left.blue": "Kék telek",
  "block.minecraft.banner.square_top_left.brown": "Barna telek",
  "block.minecraft.banner.square_top_left.cyan": "Türkizkék telek",
  "block.minecraft.banner.square_top_left.gray": "Szürke telek",
  "block.minecraft.banner.square_top_left.green": "Zöld telek",
  "block.minecraft.banner.square_top_left.light_blue": "Világoskék telek",
  "block.minecraft.banner.square_top_left.light_gray": "Világosszürke telek",
  "block.minecraft.banner.square_top_left.lime": "Világoszöld telek",
  "block.minecraft.banner.square_top_left.magenta": "Bíbor telek",
  "block.minecraft.banner.square_top_left.orange": "Narancssárga telek",
  "block.minecraft.banner.square_top_left.pink": "Rózsaszín telek",
  "block.minecraft.banner.square_top_left.purple": "Lila telek",
  "block.minecraft.banner.square_top_left.red": "Vörös telek",
  "block.minecraft.banner.square_top_left.white": "Fehér telek",
  "block.minecraft.banner.square_top_left.yellow": "Sárga telek",
  "block.minecraft.banner.square_top_right.black": "Fekete baltelek",
  "block.minecraft.banner.square_top_right.blue": "Kék baltelek",
  "block.minecraft.banner.square_top_right.brown": "Barna baltelek",
  "block.minecraft.banner.square_top_right.cyan": "Türkizkék baltelek",
  "block.minecraft.banner.square_top_right.gray": "Szürke baltelek",
  "block.minecraft.banner.square_top_right.green": "Zöld baltelek",
  "block.minecraft.banner.square_top_right.light_blue": "Világoskék baltelek",
  "block.minecraft.banner.square_top_right.light_gray": "Világosszürke baltelek",
  "block.minecraft.banner.square_top_right.lime": "Világoszöld baltelek",
  "block.minecraft.banner.square_top_right.magenta": "Bíbor baltelek",
  "block.minecraft.banner.square_top_right.orange": "Narancssárga baltelek",
  "block.minecraft.banner.square_top_right.pink": "Rózsaszín baltelek",
  "block.minecraft.banner.square_top_right.purple": "Lila baltelek",
  "block.minecraft.banner.square_top_right.red": "Vörös baltelek",
  "block.minecraft.banner.square_top_right.white": "Fehér baltelek",
  "block.minecraft.banner.square_top_right.yellow": "Sárga baltelek",
  "block.minecraft.banner.straight_cross.black": "Fekete kereszt",
  "block.minecraft.banner.straight_cross.blue": "Kék kereszt",
  "block.minecraft.banner.straight_cross.brown": "Barna kereszt",
  "block.minecraft.banner.straight_cross.cyan": "Türkizkék kereszt",
  "block.minecraft.banner.straight_cross.gray": "Szürke kereszt",
  "block.minecraft.banner.straight_cross.green": "Zöld kereszt",
  "block.minecraft.banner.straight_cross.light_blue": "Világoskék kereszt",
  "block.minecraft.banner.straight_cross.light_gray": "Világosszürke kereszt",
  "block.minecraft.banner.straight_cross.lime": "Világoszöld kereszt",
  "block.minecraft.banner.straight_cross.magenta": "Bíbor kereszt",
  "block.minecraft.banner.straight_cross.orange": "Narancssárga kereszt",
  "block.minecraft.banner.straight_cross.pink": "Rózsaszín kereszt",
  "block.minecraft.banner.straight_cross.purple": "Lila kereszt",
  "block.minecraft.banner.straight_cross.red": "Vörös kereszt",
  "block.minecraft.banner.straight_cross.white": "Fehér kereszt",
  "block.minecraft.banner.straight_cross.yellow": "Sárga kereszt",
  "block.minecraft.banner.stripe_bottom.black": "Fekete talp",
  "block.minecraft.banner.stripe_bottom.blue": "Kék talp",
  "block.minecraft.banner.stripe_bottom.brown": "Barna talp",
  "block.minecraft.banner.stripe_bottom.cyan": "Türkizkék talp",
  "block.minecraft.banner.stripe_bottom.gray": "Szürke talp",
  "block.minecraft.banner.stripe_bottom.green": "Zöld talp",
  "block.minecraft.banner.stripe_bottom.light_blue": "Világoskék talp",
  "block.minecraft.banner.stripe_bottom.light_gray": "Világosszürke talp",
  "block.minecraft.banner.stripe_bottom.lime": "Világoszöld talp",
  "block.minecraft.banner.stripe_bottom.magenta": "Bíbor talp",
  "block.minecraft.banner.stripe_bottom.orange": "Narancssárga talp",
  "block.minecraft.banner.stripe_bottom.pink": "Rózsaszín talp",
  "block.minecraft.banner.stripe_bottom.purple": "Lila talp",
  "block.minecraft.banner.stripe_bottom.red": "Vörös talp",
  "block.minecraft.banner.stripe_bottom.white": "Fehér talp",
  "block.minecraft.banner.stripe_bottom.yellow": "Sárga talp",
  "block.minecraft.banner.stripe_center.black": "Fekete cölöp",
  "block.minecraft.banner.stripe_center.blue": "Kék cölöp",
  "block.minecraft.banner.stripe_center.brown": "Barna cölöp",
  "block.minecraft.banner.stripe_center.cyan": "Türkizkék cölöp",
  "block.minecraft.banner.stripe_center.gray": "Szürke cölöp",
  "block.minecraft.banner.stripe_center.green": "Zöld cölöp",
  "block.minecraft.banner.stripe_center.light_blue": "Világoskék cölöp",
  "block.minecraft.banner.stripe_center.light_gray": "Világosszürke cölöp",
  "block.minecraft.banner.stripe_center.lime": "Világoszöld cölöp",
  "block.minecraft.banner.stripe_center.magenta": "Bíbor cölöp",
  "block.minecraft.banner.stripe_center.orange": "Narancssárga cölöp",
  "block.minecraft.banner.stripe_center.pink": "Rózsaszín cölöp",
  "block.minecraft.banner.stripe_center.purple": "Lila cölöp",
  "block.minecraft.banner.stripe_center.red": "Vörös cölöp",
  "block.minecraft.banner.stripe_center.white": "Fehér cölöp",
  "block.minecraft.banner.stripe_center.yellow": "Sárga cölöp",
  "block.minecraft.banner.stripe_downleft.black": "Fekete balharántpólya",
  "block.minecraft.banner.stripe_downleft.blue": "Kék balharántpólya",
  "block.minecraft.banner.stripe_downleft.brown": "Barna balharántpólya",
  "block.minecraft.banner.stripe_downleft.cyan": "Türkizkék balharántpólya",
  "block.minecraft.banner.stripe_downleft.gray": "Szürke balharántpólya",
  "block.minecraft.banner.stripe_downleft.green": "Zöld balharántpólya",
  "block.minecraft.banner.stripe_downleft.light_blue": "Világoskék balharántpólya",
  "block.minecraft.banner.stripe_downleft.light_gray": "Világosszürke balharántpólya",
  "block.minecraft.banner.stripe_downleft.lime": "Világoszöld balharántpólya",
  "block.minecraft.banner.stripe_downleft.magenta": "Bíbor balharántpólya",
  "block.minecraft.banner.stripe_downleft.orange": "Narancssárga balharántpólya",
  "block.minecraft.banner.stripe_downleft.pink": "Rózsaszín balharántpólya",
  "block.minecraft.banner.stripe_downleft.purple": "Lila balharántpólya",
  "block.minecraft.banner.stripe_downleft.red": "Vörös balharántpólya",
  "block.minecraft.banner.stripe_downleft.white": "Fehér balharántpólya",
  "block.minecraft.banner.stripe_downleft.yellow": "Sárga balharántpólya",
  "block.minecraft.banner.stripe_downright.black": "Fekete harántpólya",
  "block.minecraft.banner.stripe_downright.blue": "Kék harántpólya",
  "block.minecraft.banner.stripe_downright.brown": "Barna harántpólya",
  "block.minecraft.banner.stripe_downright.cyan": "Türkizkék harántpólya",
  "block.minecraft.banner.stripe_downright.gray": "Szürke harántpólya",
  "block.minecraft.banner.stripe_downright.green": "Zöld harántpólya",
  "block.minecraft.banner.stripe_downright.light_blue": "Világoskék harántpólya",
  "block.minecraft.banner.stripe_downright.light_gray": "Világosszürke harántpólya",
  "block.minecraft.banner.stripe_downright.lime": "Világoszöld harántpólya",
  "block.minecraft.banner.stripe_downright.magenta": "Bíbor harántpólya",
  "block.minecraft.banner.stripe_downright.orange": "Narancssárga harántpólya",
  "block.minecraft.banner.stripe_downright.pink": "Rózsaszín harántpólya",
  "block.minecraft.banner.stripe_downright.purple": "Lila harántpólya",
  "block.minecraft.banner.stripe_downright.red": "Vörös harántpólya",
  "block.minecraft.banner.stripe_downright.white": "Fehér harántpólya",
  "block.minecraft.banner.stripe_downright.yellow": "Sárga harántpólya",
  "block.minecraft.banner.stripe_left.black": "Fekete jobb cölöp",
  "block.minecraft.banner.stripe_left.blue": "Kék jobb cölöp",
  "block.minecraft.banner.stripe_left.brown": "Barna jobb cölöp",
  "block.minecraft.banner.stripe_left.cyan": "Türkizkék jobb cölöp",
  "block.minecraft.banner.stripe_left.gray": "Szürke jobb cölöp",
  "block.minecraft.banner.stripe_left.green": "Zöld jobb cölöp",
  "block.minecraft.banner.stripe_left.light_blue": "Világoskék jobb cölöp",
  "block.minecraft.banner.stripe_left.light_gray": "Világosszürke jobb cölöp",
  "block.minecraft.banner.stripe_left.lime": "Világoszöld jobb cölöp",
  "block.minecraft.banner.stripe_left.magenta": "Bíbor jobb cölöp",
  "block.minecraft.banner.stripe_left.orange": "Narancssárga jobb cölöp",
  "block.minecraft.banner.stripe_left.pink": "Rózsaszín jobb cölöp",
  "block.minecraft.banner.stripe_left.purple": "Lila jobb cölöp",
  "block.minecraft.banner.stripe_left.red": "Vörös jobb cölöp",
  "block.minecraft.banner.stripe_left.white": "Fehér jobb cölöp",
  "block.minecraft.banner.stripe_left.yellow": "Sárga jobb cölöp",
  "block.minecraft.banner.stripe_middle.black": "Fekete csík",
  "block.minecraft.banner.stripe_middle.blue": "Kék csík",
  "block.minecraft.banner.stripe_middle.brown": "Barna csík",
  "block.minecraft.banner.stripe_middle.cyan": "Türkizkék csík",
  "block.minecraft.banner.stripe_middle.gray": "Szürke csík",
  "block.minecraft.banner.stripe_middle.green": "Zöld csík",
  "block.minecraft.banner.stripe_middle.light_blue": "Világoskék csík",
  "block.minecraft.banner.stripe_middle.light_gray": "Világosszürke csík",
  "block.minecraft.banner.stripe_middle.lime": "Világoszöld csík",
  "block.minecraft.banner.stripe_middle.magenta": "Bíbor csík",
  "block.minecraft.banner.stripe_middle.orange": "Narancssárga csík",
  "block.minecraft.banner.stripe_middle.pink": "Rózsaszín csík",
  "block.minecraft.banner.stripe_middle.purple": "Lila csík",
  "block.minecraft.banner.stripe_middle.red": "Vörös csík",
  "block.minecraft.banner.stripe_middle.white": "Fehér csík",
  "block.minecraft.banner.stripe_middle.yellow": "Sárga csík",
  "block.minecraft.banner.stripe_right.black": "Fekete bal cölöp",
  "block.minecraft.banner.stripe_right.blue": "Kék bal cölöp",
  "block.minecraft.banner.stripe_right.brown": "Barna bal cölöp",
  "block.minecraft.banner.stripe_right.cyan": "Türkizkék bal cölöp",
  "block.minecraft.banner.stripe_right.gray": "Szürke bal cölöp",
  "block.minecraft.banner.stripe_right.green": "Zöld bal cölöp",
  "block.minecraft.banner.stripe_right.light_blue": "Világoskék bal cölöp",
  "block.minecraft.banner.stripe_right.light_gray": "Világosszürke bal cölöp",
  "block.minecraft.banner.stripe_right.lime": "Világoszöld bal cölöp",
  "block.minecraft.banner.stripe_right.magenta": "Bíbor bal cölöp",
  "block.minecraft.banner.stripe_right.orange": "Narancssárga bal cölöp",
  "block.minecraft.banner.stripe_right.pink": "Rózsaszín bal cölöp",
  "block.minecraft.banner.stripe_right.purple": "Lila bal cölöp",
  "block.minecraft.banner.stripe_right.red": "Vörös bal cölöp",
  "block.minecraft.banner.stripe_right.white": "Fehér bal cölöp",
  "block.minecraft.banner.stripe_right.yellow": "Sárga bal cölöp",
  "block.minecraft.banner.stripe_top.black": "Fekete fő",
  "block.minecraft.banner.stripe_top.blue": "Kék fő",
  "block.minecraft.banner.stripe_top.brown": "Barna fő",
  "block.minecraft.banner.stripe_top.cyan": "Türkizkék fő",
  "block.minecraft.banner.stripe_top.gray": "Szürke fő",
  "block.minecraft.banner.stripe_top.green": "Zöld fő",
  "block.minecraft.banner.stripe_top.light_blue": "Világoskék fő",
  "block.minecraft.banner.stripe_top.light_gray": "Világosszürke fő",
  "block.minecraft.banner.stripe_top.lime": "Világoszöld fő",
  "block.minecraft.banner.stripe_top.magenta": "Bíbor fő",
  "block.minecraft.banner.stripe_top.orange": "Narancssárga fő",
  "block.minecraft.banner.stripe_top.pink": "Rózsaszín fő",
  "block.minecraft.banner.stripe_top.purple": "Lila fő",
  "block.minecraft.banner.stripe_top.red": "Vörös fő",
  "block.minecraft.banner.stripe_top.white": "Fehér fő",
  "block.minecraft.banner.stripe_top.yellow": "Sárga fő",
  "block.minecraft.banner.triangle_bottom.black": "Fekete fordított ék",
  "block.minecraft.banner.triangle_bottom.blue": "Kék fordított ék",
  "block.minecraft.banner.triangle_bottom.brown": "Barna fordított ék",
  "block.minecraft.banner.triangle_bottom.cyan": "Türkizkék fordított ék",
  "block.minecraft.banner.triangle_bottom.gray": "Szürke fordított ék",
  "block.minecraft.banner.triangle_bottom.green": "Zöld fordított ék",
  "block.minecraft.banner.triangle_bottom.light_blue": "Világoskék fordított ék",
  "block.minecraft.banner.triangle_bottom.light_gray": "Világosszürke fordított ék",
  "block.minecraft.banner.triangle_bottom.lime": "Világoszöld fordított ék",
  "block.minecraft.banner.triangle_bottom.magenta": "Bíbor fordított ék",
  "block.minecraft.banner.triangle_bottom.orange": "Narancssárga fordított ék",
  "block.minecraft.banner.triangle_bottom.pink": "Rózsaszín fordított ék",
  "block.minecraft.banner.triangle_bottom.purple": "Lila fordított ék",
  "block.minecraft.banner.triangle_bottom.red": "Vörös fordított ék",
  "block.minecraft.banner.triangle_bottom.white": "Fehér fordított ék",
  "block.minecraft.banner.triangle_bottom.yellow": "Sárga fordított ék",
  "block.minecraft.banner.triangle_top.black": "Fekete ék",
  "block.minecraft.banner.triangle_top.blue": "Kék ék",
  "block.minecraft.banner.triangle_top.brown": "Barna ék",
  "block.minecraft.banner.triangle_top.cyan": "Türkizkék ék",
  "block.minecraft.banner.triangle_top.gray": "Szürke ék",
  "block.minecraft.banner.triangle_top.green": "Zöld ék",
  "block.minecraft.banner.triangle_top.light_blue": "Világoskék ék",
  "block.minecraft.banner.triangle_top.light_gray": "Világosszürke ék",
  "block.minecraft.banner.triangle_top.lime": "Világoszöld ék",
  "block.minecraft.banner.triangle_top.magenta": "Bíbor ék",
  "block.minecraft.banner.triangle_top.orange": "Narancssárga ék",
  "block.minecraft.banner.triangle_top.pink": "Rózsaszín ék",
  "block.minecraft.banner.triangle_top.purple": "Lila ék",
  "block.minecraft.banner.triangle_top.red": "Vörös ék",
  "block.minecraft.banner.triangle_top.white": "Fehér ék",
  "block.minecraft.banner.triangle_top.yellow": "Sárgával saruzott",
  "block.minecraft.banner.triangles_bottom.black": "Fekete fogas talp",
  "block.minecraft.banner.triangles_bottom.blue": "Kék fogas talp",
  "block.minecraft.banner.triangles_bottom.brown": "Barna fogas talp",
  "block.minecraft.banner.triangles_bottom.cyan": "Türkizkék fogas talp",
  "block.minecraft.banner.triangles_bottom.gray": "Szürke fogas talp",
  "block.minecraft.banner.triangles_bottom.green": "Zöld fogas talp",
  "block.minecraft.banner.triangles_bottom.light_blue": "Világoskék fogas talp",
  "block.minecraft.banner.triangles_bottom.light_gray": "Világosszürke fogas talp",
  "block.minecraft.banner.triangles_bottom.lime": "Világoszöld fogas talp",
  "block.minecraft.banner.triangles_bottom.magenta": "Bíbor fogas talp",
  "block.minecraft.banner.triangles_bottom.orange": "Narancssárga fogas talp",
  "block.minecraft.banner.triangles_bottom.pink": "Rózsaszín fogas talp",
  "block.minecraft.banner.triangles_bottom.purple": "Lila fogas talp",
  "block.minecraft.banner.triangles_bottom.red": "Vörös fogas talp",
  "block.minecraft.banner.triangles_bottom.white": "Fehér fogas talp",
  "block.minecraft.banner.triangles_bottom.yellow": "Sárga fogas talp",
  "block.minecraft.banner.triangles_top.black": "Fekete fogas fő",
  "block.minecraft.banner.triangles_top.blue": "Kék fogas fő",
  "block.minecraft.banner.triangles_top.brown": "Barna fogas fő",
  "block.minecraft.banner.triangles_top.cyan": "Türkizkék fogas fő",
  "block.minecraft.banner.triangles_top.gray": "Szürke fogas fő",
  "block.minecraft.banner.triangles_top.green": "Zöld fogas fő",
  "block.minecraft.banner.triangles_top.light_blue": "Világoskék fogas fő",
  "block.minecraft.banner.triangles_top.light_gray": "Világosszürke fogas fő",
  "block.minecraft.banner.triangles_top.lime": "Világoszöld fogas fő",
  "block.minecraft.banner.triangles_top.magenta": "Bíbor fogas fő",
  "block.minecraft.banner.triangles_top.orange": "Narancssárga fogas fő",
  "block.minecraft.banner.triangles_top.pink": "Rózsaszín fogas fő",
  "block.minecraft.banner.triangles_top.purple": "Lila fogas fő",
  "block.minecraft.banner.triangles_top.red": "Vörös fogas fő",
  "block.minecraft.banner.triangles_top.white": "Fehér fogas fő",
  "block.minecraft.banner.triangles_top.yellow": "Sárga fogas fő",
  "block.minecraft.barrel": "Hordó",
  "block.minecraft.barrier": "Akadály",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Jelzőfény",
  "block.minecraft.beacon.primary": "Elsődleges képesség",
  "block.minecraft.beacon.secondary": "Másodlagos képesség",
  "block.minecraft.bed.no_sleep": "Csak éjjel vagy viharos időben aludhatsz",
  "block.minecraft.bed.not_safe": "Most nem pihenhetsz, mert szörnyek vannak a közeledben",
  "block.minecraft.bed.obstructed": "Ez az ágy nem hozzáférhető",
  "block.minecraft.bed.occupied": "Ez az ágy foglalt",
  "block.minecraft.bed.too_far_away": "Most nem pihenhetsz, túl messze van az ágyad",
  "block.minecraft.bedrock": "Alapkő",
  "block.minecraft.bee_nest": "Méhkas",
  "block.minecraft.beehive": "Méhkaptár",
  "block.minecraft.beetroots": "Cékla",
  "block.minecraft.bell": "Harang",
  "block.minecraft.big_dripleaf": "Nagy csepplevél",
  "block.minecraft.big_dripleaf_stem": "Nagy csepplevél szára",
  "block.minecraft.birch_button": "Nyírfa gomb",
  "block.minecraft.birch_door": "Nyírfa ajtó",
  "block.minecraft.birch_fence": "Nyírfa kerítés",
  "block.minecraft.birch_fence_gate": "Nyírfa kerítéskapu",
  "block.minecraft.birch_hanging_sign": "Nyírfa függőtábla",
  "block.minecraft.birch_leaves": "Nyírfalevelek",
  "block.minecraft.birch_log": "Nyírfarönk",
  "block.minecraft.birch_planks": "Nyírfa deszka",
  "block.minecraft.birch_pressure_plate": "Nyírfa nyomólap",
  "block.minecraft.birch_sapling": "Nyírfacsemete",
  "block.minecraft.birch_shelf": "Nyírfa polc",
  "block.minecraft.birch_sign": "Nyírfa tábla",
  "block.minecraft.birch_slab": "Nyírfa lap",
  "block.minecraft.birch_stairs": "Nyírfa lépcső",
  "block.minecraft.birch_trapdoor": "Nyírfa csapóajtó",
  "block.minecraft.birch_wall_hanging_sign": "Nyírfa fali függőtábla",
  "block.minecraft.birch_wall_sign": "Nyírfa falitábla",
  "block.minecraft.birch_wood": "Nyírfablokk",
  "block.minecraft.black_banner": "Fekete zászló",
  "block.minecraft.black_bed": "Fekete ágy",
  "block.minecraft.black_candle": "Fekete gyertya",
  "block.minecraft.black_candle_cake": "Torta fekete gyertyával",
  "block.minecraft.black_carpet": "Fekete szőnyeg",
  "block.minecraft.black_concrete": "Fekete beton",
  "block.minecraft.black_concrete_powder": "Fekete szárazbeton",
  "block.minecraft.black_glazed_terracotta": "Fekete mázas kerámia",
  "block.minecraft.black_shulker_box": "Fekete shulkerdoboz",
  "block.minecraft.black_stained_glass": "Fekete festett üveg",
  "block.minecraft.black_stained_glass_pane": "Fekete festett üveglap",
  "block.minecraft.black_terracotta": "Fekete terrakotta",
  "block.minecraft.black_wool": "Fekete gyapjú",
  "block.minecraft.blackstone": "Feketekő",
  "block.minecraft.blackstone_slab": "Feketekő lap",
  "block.minecraft.blackstone_stairs": "Feketekő lépcső",
  "block.minecraft.blackstone_wall": "Feketekő fal",
  "block.minecraft.blast_furnace": "Kohó",
  "block.minecraft.blue_banner": "Kék zászló",
  "block.minecraft.blue_bed": "Kék ágy",
  "block.minecraft.blue_candle": "Kék gyertya",
  "block.minecraft.blue_candle_cake": "Torta kék gyertyával",
  "block.minecraft.blue_carpet": "Kék szőnyeg",
  "block.minecraft.blue_concrete": "Kék beton",
  "block.minecraft.blue_concrete_powder": "Kék szárazbeton",
  "block.minecraft.blue_glazed_terracotta": "Kék mázas kerámia",
  "block.minecraft.blue_ice": "Kék jég",
  "block.minecraft.blue_orchid": "Kék orchidea",
  "block.minecraft.blue_shulker_box": "Kék shulkerdoboz",
  "block.minecraft.blue_stained_glass": "Kék festett üveg",
  "block.minecraft.blue_stained_glass_pane": "Kék festett üveglap",
  "block.minecraft.blue_terracotta": "Kék terrakotta",
  "block.minecraft.blue_wool": "Kék gyapjú",
  "block.minecraft.bone_block": "Csontblokk",
  "block.minecraft.bookshelf": "Könyvespolc",
  "block.minecraft.brain_coral": "Agykorall",
  "block.minecraft.brain_coral_block": "Agykorall-blokk",
  "block.minecraft.brain_coral_fan": "Agykorall-legyező",
  "block.minecraft.brain_coral_wall_fan": "Fali agykorall-legyező",
  "block.minecraft.brewing_stand": "Főzőállvány",
  "block.minecraft.brick_slab": "Tégla-lap",
  "block.minecraft.brick_stairs": "Téglalépcső",
  "block.minecraft.brick_wall": "Téglafal",
  "block.minecraft.bricks": "Tégla",
  "block.minecraft.brown_banner": "Barna zászló",
  "block.minecraft.brown_bed": "Barna ágy",
  "block.minecraft.brown_candle": "Barna gyertya",
  "block.minecraft.brown_candle_cake": "Torta barna gyertyával",
  "block.minecraft.brown_carpet": "Barna szőnyeg",
  "block.minecraft.brown_concrete": "Barna beton",
  "block.minecraft.brown_concrete_powder": "Barna szárazbeton",
  "block.minecraft.brown_glazed_terracotta": "Barna mázas kerámia",
  "block.minecraft.brown_mushroom": "Barna gomba",
  "block.minecraft.brown_mushroom_block": "Barna gombablokk",
  "block.minecraft.brown_shulker_box": "Barna shulkerdoboz",
  "block.minecraft.brown_stained_glass": "Barna festett üveg",
  "block.minecraft.brown_stained_glass_pane": "Barna festett üveglap",
  "block.minecraft.brown_terracotta": "Barna terrakotta",
  "block.minecraft.brown_wool": "Barna gyapjú",
  "block.minecraft.bubble_column": "Buborékoszlop",
  "block.minecraft.bubble_coral": "Buborékkorall",
  "block.minecraft.bubble_coral_block": "Buborékkorall-blokk",
  "block.minecraft.bubble_coral_fan": "Buborékkorall-legyező",
  "block.minecraft.bubble_coral_wall_fan": "Fali buborékkorall-legyező",
  "block.minecraft.budding_amethyst": "Kristályosodó ametiszt",
  "block.minecraft.bush": "Cserje",
  "block.minecraft.cactus": "Kaktusz",
  "block.minecraft.cactus_flower": "Kaktuszvirág",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Behangolt sculkérzékelő",
  "block.minecraft.campfire": "Tábortűz",
  "block.minecraft.candle": "Gyertya",
  "block.minecraft.candle_cake": "Torta gyertyával",
  "block.minecraft.carrots": "Sárgarépák",
  "block.minecraft.cartography_table": "Térképasztal",
  "block.minecraft.carved_pumpkin": "Faragott tök",
  "block.minecraft.cauldron": "Üst",
  "block.minecraft.cave_air": "Barlangi levegő",
  "block.minecraft.cave_vines": "Barlangi indák",
  "block.minecraft.cave_vines_plant": "Barlangi indaszár",
  "block.minecraft.chain": "Vaslánc",
  "block.minecraft.chain_command_block": "Láncolt parancsblokk",
  "block.minecraft.cherry_button": "Cseresznyefa gomb",
  "block.minecraft.cherry_door": "Cseresznyefa ajtó",
  "block.minecraft.cherry_fence": "Cseresznyefa kerítés",
  "block.minecraft.cherry_fence_gate": "Cseresznyefa kerítéskapu",
  "block.minecraft.cherry_hanging_sign": "Cseresznyefa függőtábla",
  "block.minecraft.cherry_leaves": "Cseresznyefa-levelek",
  "block.minecraft.cherry_log": "Cseresznyefarönk",
  "block.minecraft.cherry_planks": "Cseresznyefa deszka",
  "block.minecraft.cherry_pressure_plate": "Cseresznyefa nyomólap",
  "block.minecraft.cherry_sapling": "Cseresznyefa-csemete",
  "block.minecraft.cherry_shelf": "Cseresznyefa polc",
  "block.minecraft.cherry_sign": "Cseresznyefa tábla",
  "block.minecraft.cherry_slab": "Cseresznyefa lap",
  "block.minecraft.cherry_stairs": "Cseresznyefa lépcső",
  "block.minecraft.cherry_trapdoor": "Cseresznyefa csapóajtó",
  "block.minecraft.cherry_wall_hanging_sign": "Cseresznyefa fali függőtábla",
  "block.minecraft.cherry_wall_sign": "Cseresznyefa falitábla",
  "block.minecraft.cherry_wood": "Cseresznyefablokk",
  "block.minecraft.chest": "Láda",
  "block.minecraft.chipped_anvil": "Repedt üllő",
  "block.minecraft.chiseled_bookshelf": "Faragott könyvespolc",
  "block.minecraft.chiseled_copper": "Vésett rézblokk",
  "block.minecraft.chiseled_deepslate": "Vésett mélypala",
  "block.minecraft.chiseled_nether_bricks": "Vésett nethertégla",
  "block.minecraft.chiseled_polished_blackstone": "Vésett csiszolt feketekő",
  "block.minecraft.chiseled_quartz_block": "Vésett kvarcblokk",
  "block.minecraft.chiseled_red_sandstone": "Vésett vörös homokkő",
  "block.minecraft.chiseled_resin_bricks": "Vésett gyantatégla",
  "block.minecraft.chiseled_sandstone": "Vésett homokkő",
  "block.minecraft.chiseled_stone_bricks": "Vésett kőtégla",
  "block.minecraft.chiseled_tuff": "Vésett tufa",
  "block.minecraft.chiseled_tuff_bricks": "Vésett tufatégla",
  "block.minecraft.chorus_flower": "Refrénvirág",
  "block.minecraft.chorus_plant": "Refrénnövény",
  "block.minecraft.clay": "Agyag",
  "block.minecraft.closed_eyeblossom": "Zárt szemvirág",
  "block.minecraft.coal_block": "Szénblokk",
  "block.minecraft.coal_ore": "Szénérc",
  "block.minecraft.coarse_dirt": "Terméketlen föld",
  "block.minecraft.cobbled_deepslate": "Zúzott mélypala",
  "block.minecraft.cobbled_deepslate_slab": "Zúzott-mélypala lap",
  "block.minecraft.cobbled_deepslate_stairs": "Zúzott-mélypala lépcső",
  "block.minecraft.cobbled_deepslate_wall": "Zúzott-mélypala fal",
  "block.minecraft.cobblestone": "Zúzottkő",
  "block.minecraft.cobblestone_slab": "Zúzottkő lap",
  "block.minecraft.cobblestone_stairs": "Zúzottkő lépcső",
  "block.minecraft.cobblestone_wall": "Zúzottkő-fal",
  "block.minecraft.cobweb": "Pókháló",
  "block.minecraft.cocoa": "Kakaó",
  "block.minecraft.command_block": "Parancsblokk",
  "block.minecraft.comparator": "Redstone-komparátor",
  "block.minecraft.composter": "Komposztáló",
  "block.minecraft.conduit": "Csatorna",
  "block.minecraft.copper_bars": "Rézrács",
  "block.minecraft.copper_block": "Rézblokk",
  "block.minecraft.copper_bulb": "Rézizzó",
  "block.minecraft.copper_chain": "Rézlánc",
  "block.minecraft.copper_chest": "Rézláda",
  "block.minecraft.copper_door": "Rézajtó",
  "block.minecraft.copper_golem_statue": "Rézgólem-szobor",
  "block.minecraft.copper_grate": "Rézrostély",
  "block.minecraft.copper_lantern": "Rézlámpás",
  "block.minecraft.copper_ore": "Rézérc",
  "block.minecraft.copper_torch": "Rézfáklya",
  "block.minecraft.copper_trapdoor": "Réz csapóajtó",
  "block.minecraft.copper_wall_torch": "Fali rézfáklya",
  "block.minecraft.cornflower": "Búzavirág",
  "block.minecraft.cracked_deepslate_bricks": "Repedt mélypalatégla",
  "block.minecraft.cracked_deepslate_tiles": "Repedt mélypalacsempe",
  "block.minecraft.cracked_nether_bricks": "Repedt nethertégla",
  "block.minecraft.cracked_polished_blackstone_bricks": "Repedt csiszolt feketekőtégla",
  "block.minecraft.cracked_stone_bricks": "Repedezett kőtégla",
  "block.minecraft.crafter": "Barkácsoló",
  "block.minecraft.crafting_table": "Barkácsasztal",
  "block.minecraft.creaking_heart": "Nyikorgószív",
  "block.minecraft.creeper_head": "Creeperfej",
  "block.minecraft.creeper_wall_head": "Fali creeperfej",
  "block.minecraft.crimson_button": "Karmazsin gomb",
  "block.minecraft.crimson_door": "Karmazsin ajtó",
  "block.minecraft.crimson_fence": "Karmazsin kerítés",
  "block.minecraft.crimson_fence_gate": "Karmazsin kerítéskapu",
  "block.minecraft.crimson_fungus": "Karmazsin gomba",
  "block.minecraft.crimson_hanging_sign": "Karmazsin függőtábla",
  "block.minecraft.crimson_hyphae": "Karmazsin gombafonalak",
  "block.minecraft.crimson_nylium": "Karmazsin nílium",
  "block.minecraft.crimson_planks": "Karmazsin deszka",
  "block.minecraft.crimson_pressure_plate": "Karmazsin nyomólap",
  "block.minecraft.crimson_roots": "Karmazsin gyökerek",
  "block.minecraft.crimson_shelf": "Karmazsin polc",
  "block.minecraft.crimson_sign": "Karmazsin tábla",
  "block.minecraft.crimson_slab": "Karmazsin deszkalap",
  "block.minecraft.crimson_stairs": "Karmazsin lépcső",
  "block.minecraft.crimson_stem": "Karmazsin tönk",
  "block.minecraft.crimson_trapdoor": "Karmazsin csapóajtó",
  "block.minecraft.crimson_wall_hanging_sign": "Karmazsin fali függőtábla",
  "block.minecraft.crimson_wall_sign": "Karmazsin falitábla",
  "block.minecraft.crying_obsidian": "Könnyező obszidián",
  "block.minecraft.cut_copper": "Vágott rézblokk",
  "block.minecraft.cut_copper_slab": "Vágott rézlap",
  "block.minecraft.cut_copper_stairs": "Vágott rézlépcső",
  "block.minecraft.cut_red_sandstone": "Vágott vörös homokkő",
  "block.minecraft.cut_red_sandstone_slab": "Vágott vörös homokkő lap",
  "block.minecraft.cut_sandstone": "Vágott homokkő",
  "block.minecraft.cut_sandstone_slab": "Vágott homokkő lap",
  "block.minecraft.cyan_banner": "Türkizkék zászló",
  "block.minecraft.cyan_bed": "Türkizkék ágy",
  "block.minecraft.cyan_candle": "Türkizkék gyertya",
  "block.minecraft.cyan_candle_cake": "Torta türkizkék gyertyával",
  "block.minecraft.cyan_carpet": "Türkizkék szőnyeg",
  "block.minecraft.cyan_concrete": "Türkizkék beton",
  "block.minecraft.cyan_concrete_powder": "Türkizkék szárazbeton",
  "block.minecraft.cyan_glazed_terracotta": "Türkizkék mázas kerámia",
  "block.minecraft.cyan_shulker_box": "Türkizkék shulkerdoboz",
  "block.minecraft.cyan_stained_glass": "Türkizkék festett üveg",
  "block.minecraft.cyan_stained_glass_pane": "Türkizkék festett üveglap",
  "block.minecraft.cyan_terracotta": "Türkizkék terrakotta",
  "block.minecraft.cyan_wool": "Türkizkék gyapjú",
  "block.minecraft.damaged_anvil": "Sérült üllő",
  "block.minecraft.dandelion": "Pitypang",
  "block.minecraft.dark_oak_button": "Sötéttölgy gomb",
  "block.minecraft.dark_oak_door": "Sötéttölgy ajtó",
  "block.minecraft.dark_oak_fence": "Sötéttölgy kerítés",
  "block.minecraft.dark_oak_fence_gate": "Sötéttölgy kerítéskapu",
  "block.minecraft.dark_oak_hanging_sign": "Sötéttölgy függőtábla",
  "block.minecraft.dark_oak_leaves": "Sötéttölgy-levelek",
  "block.minecraft.dark_oak_log": "Sötéttölgy-rönk",
  "block.minecraft.dark_oak_planks": "Sötéttölgy deszka",
  "block.minecraft.dark_oak_pressure_plate": "Sötéttölgy nyomólap",
  "block.minecraft.dark_oak_sapling": "Sötéttölgy-csemete",
  "block.minecraft.dark_oak_shelf": "Sötéttölgy polc",
  "block.minecraft.dark_oak_sign": "Sötéttölgy tábla",
  "block.minecraft.dark_oak_slab": "Sötéttölgy lap",
  "block.minecraft.dark_oak_stairs": "Sötéttölgy lépcső",
  "block.minecraft.dark_oak_trapdoor": "Sötéttölgy csapóajtó",
  "block.minecraft.dark_oak_wall_hanging_sign": "Sötéttölgy fali függőtábla",
  "block.minecraft.dark_oak_wall_sign": "Sötéttölgy falitábla",
  "block.minecraft.dark_oak_wood": "Sötéttölgyblokk",
  "block.minecraft.dark_prismarine": "Sötét prizmarin",
  "block.minecraft.dark_prismarine_slab": "Sötét prizmarinlap",
  "block.minecraft.dark_prismarine_stairs": "Sötét prizmarinlépcső",
  "block.minecraft.daylight_detector": "Napfényérzékelő",
  "block.minecraft.dead_brain_coral": "Elhalt agykorall",
  "block.minecraft.dead_brain_coral_block": "Elhalt agykorall-blokk",
  "block.minecraft.dead_brain_coral_fan": "Elhalt agykorall-legyező",
  "block.minecraft.dead_brain_coral_wall_fan": "Elhalt fali agykorall-legyező",
  "block.minecraft.dead_bubble_coral": "Elhalt buborékkorall",
  "block.minecraft.dead_bubble_coral_block": "Elhalt buborékkorall-blokk",
  "block.minecraft.dead_bubble_coral_fan": "Elhalt buborékkorall-legyező",
  "block.minecraft.dead_bubble_coral_wall_fan": "Elhalt fali buborékkorall-legyező",
  "block.minecraft.dead_bush": "Száraz kóró",
  "block.minecraft.dead_fire_coral": "Elhalt tűzkorall",
  "block.minecraft.dead_fire_coral_block": "Elhalt tűzkorall-blokk",
  "block.minecraft.dead_fire_coral_fan": "Elhalt tűzkorall-legyező",
  "block.minecraft.dead_fire_coral_wall_fan": "Elhalt fali tűzkorall-legyező",
  "block.minecraft.dead_horn_coral": "Elhalt agancskorall",
  "block.minecraft.dead_horn_coral_block": "Elhalt agancskorall-blokk",
  "block.minecraft.dead_horn_coral_fan": "Elhalt agancskorall-legyező",
  "block.minecraft.dead_horn_coral_wall_fan": "Elhalt fali agancskorall-legyező",
  "block.minecraft.dead_tube_coral": "Elhalt csőkorall",
  "block.minecraft.dead_tube_coral_block": "Elhalt csőkorall-blokk",
  "block.minecraft.dead_tube_coral_fan": "Elhalt csőkorall-legyező",
  "block.minecraft.dead_tube_coral_wall_fan": "Elhalt fali csőkorall-legyező",
  "block.minecraft.decorated_pot": "Díszített cserépedény",
  "block.minecraft.deepslate": "Mélypala",
  "block.minecraft.deepslate_brick_slab": "Mélypalatégla lap",
  "block.minecraft.deepslate_brick_stairs": "Mélypalatégla-lépcső",
  "block.minecraft.deepslate_brick_wall": "Mélypalatégla-fal",
  "block.minecraft.deepslate_bricks": "Mélypalatégla",
  "block.minecraft.deepslate_coal_ore": "Szénérc mélypalában",
  "block.minecraft.deepslate_copper_ore": "Rézérc mélypalában",
  "block.minecraft.deepslate_diamond_ore": "Gyémántérc mélypalában",
  "block.minecraft.deepslate_emerald_ore": "Smaragdérc mélypalában",
  "block.minecraft.deepslate_gold_ore": "Aranyérc mélypalában",
  "block.minecraft.deepslate_iron_ore": "Vasérc mélypalában",
  "block.minecraft.deepslate_lapis_ore": "Lazuritérc mélypalában",
  "block.minecraft.deepslate_redstone_ore": "Redstone-érc mélypalában",
  "block.minecraft.deepslate_tile_slab": "Mélypalacsempe-lap",
  "block.minecraft.deepslate_tile_stairs": "Mélypalacsempe-lépcső",
  "block.minecraft.deepslate_tile_wall": "Mélypalacsempe-fal",
  "block.minecraft.deepslate_tiles": "Mélypala csempe",
  "block.minecraft.detector_rail": "Érzékelősín",
  "block.minecraft.diamond_block": "Gyémántblokk",
  "block.minecraft.diamond_ore": "Gyémántérc",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritlap",
  "block.minecraft.diorite_stairs": "Dioritlépcső",
  "block.minecraft.diorite_wall": "Dioritfal",
  "block.minecraft.dirt": "Föld",
  "block.minecraft.dirt_path": "Ösvény",
  "block.minecraft.dispenser": "Adagoló",
  "block.minecraft.dragon_egg": "Sárkánytojás",
  "block.minecraft.dragon_head": "Sárkányfej",
  "block.minecraft.dragon_wall_head": "Fali sárkányfej",
  "block.minecraft.dried_ghast": "Kiszáradt Ghast",
  "block.minecraft.dried_kelp_block": "Szárított hínárblokk",
  "block.minecraft.dripstone_block": "Cseppkőblokk",
  "block.minecraft.dropper": "Kidobó",
  "block.minecraft.emerald_block": "Smaragdblokk",
  "block.minecraft.emerald_ore": "Smaragdérc",
  "block.minecraft.enchanting_table": "Varázslóasztal",
  "block.minecraft.end_gateway": "End-kapu",
  "block.minecraft.end_portal": "End-portál",
  "block.minecraft.end_portal_frame": "Endportál-keret",
  "block.minecraft.end_rod": "End-rúd",
  "block.minecraft.end_stone": "Endkő",
  "block.minecraft.end_stone_brick_slab": "Endkőtégla lap",
  "block.minecraft.end_stone_brick_stairs": "Endkőtégla-lépcső",
  "block.minecraft.end_stone_brick_wall": "Endkőtégla-fal",
  "block.minecraft.end_stone_bricks": "Endkőtégla",
  "block.minecraft.ender_chest": "Enderláda",
  "block.minecraft.exposed_chiseled_copper": "Megviselt vésett rézblokk",
  "block.minecraft.exposed_copper": "Megviselt rézblokk",
  "block.minecraft.exposed_copper_bars": "Megviselt rézrács",
  "block.minecraft.exposed_copper_bulb": "Megviselt rézizzó",
  "block.minecraft.exposed_copper_chain": "Megviselt rézlánc",
  "block.minecraft.exposed_copper_chest": "Megviselt rézláda",
  "block.minecraft.exposed_copper_door": "Megviselt rézajtó",
  "block.minecraft.exposed_copper_golem_statue": "Megviselt rézgólem-szobor",
  "block.minecraft.exposed_copper_grate": "Megviselt rézrostély",
  "block.minecraft.exposed_copper_lantern": "Megviselt rézlámpás",
  "block.minecraft.exposed_copper_trapdoor": "Megviselt réz csapóajtó",
  "block.minecraft.exposed_cut_copper": "Megviselt vágott rézblokk",
  "block.minecraft.exposed_cut_copper_slab": "Megviselt vágott rézlap",
  "block.minecraft.exposed_cut_copper_stairs": "Megviselt vágott rézlépcső",
  "block.minecraft.exposed_lightning_rod": "Megviselt villámhárító",
  "block.minecraft.farmland": "Termőföld",
  "block.minecraft.fern": "Páfrány",
  "block.minecraft.fire": "Tűz",
  "block.minecraft.fire_coral": "Tűzkorall",
  "block.minecraft.fire_coral_block": "Tűzkorall-blokk",
  "block.minecraft.fire_coral_fan": "Tűzkorall-legyező",
  "block.minecraft.fire_coral_wall_fan": "Fali tűzkorall-legyező",
  "block.minecraft.firefly_bush": "Szentjánosbogár-bokor",
  "block.minecraft.fletching_table": "Íjászasztal",
  "block.minecraft.flower_pot": "Virágcserép",
  "block.minecraft.flowering_azalea": "Virágzó azálea",
  "block.minecraft.flowering_azalea_leaves": "Virágzó azálealevelek",
  "block.minecraft.frogspawn": "Békapeték",
  "block.minecraft.frosted_ice": "Gyorsfagyasztott jég",
  "block.minecraft.furnace": "Kemence",
  "block.minecraft.gilded_blackstone": "Aranyozott feketekő",
  "block.minecraft.glass": "Üveg",
  "block.minecraft.glass_pane": "Üveglap",
  "block.minecraft.glow_lichen": "Fénylő zuzmó",
  "block.minecraft.glowstone": "Izzókő",
  "block.minecraft.gold_block": "Aranyblokk",
  "block.minecraft.gold_ore": "Aranyérc",
  "block.minecraft.golden_dandelion": "Aranypitypang",
  "block.minecraft.granite": "Gránit",
  "block.minecraft.granite_slab": "Gránitlap",
  "block.minecraft.granite_stairs": "Gránitlépcső",
  "block.minecraft.granite_wall": "Gránitfal",
  "block.minecraft.grass": "Fű",
  "block.minecraft.grass_block": "Füves földblokk",
  "block.minecraft.gravel": "Sóder",
  "block.minecraft.gray_banner": "Szürke zászló",
  "block.minecraft.gray_bed": "Szürke ágy",
  "block.minecraft.gray_candle": "Szürke gyertya",
  "block.minecraft.gray_candle_cake": "Torta szürke gyertyával",
  "block.minecraft.gray_carpet": "Szürke szőnyeg",
  "block.minecraft.gray_concrete": "Szürke beton",
  "block.minecraft.gray_concrete_powder": "Szürke szárazbeton",
  "block.minecraft.gray_glazed_terracotta": "Szürke mázas kerámia",
  "block.minecraft.gray_shulker_box": "Szürke shulkerdoboz",
  "block.minecraft.gray_stained_glass": "Szürke festett üveg",
  "block.minecraft.gray_stained_glass_pane": "Szürke festett üveglap",
  "block.minecraft.gray_terracotta": "Szürke terrakotta",
  "block.minecraft.gray_wool": "Szürke gyapjú",
  "block.minecraft.green_banner": "Zöld zászló",
  "block.minecraft.green_bed": "Zöld ágy",
  "block.minecraft.green_candle": "Zöld gyertya",
  "block.minecraft.green_candle_cake": "Torta zöld gyertyával",
  "block.minecraft.green_carpet": "Zöld szőnyeg",
  "block.minecraft.green_concrete": "Zöld beton",
  "block.minecraft.green_concrete_powder": "Zöld szárazbeton",
  "block.minecraft.green_glazed_terracotta": "Zöld mázas kerámia",
  "block.minecraft.green_shulker_box": "Zöld shulkerdoboz",
  "block.minecraft.green_stained_glass": "Zöld festett üveg",
  "block.minecraft.green_stained_glass_pane": "Zöld festett üveglap",
  "block.minecraft.green_terracotta": "Zöld terrakotta",
  "block.minecraft.green_wool": "Zöld gyapjú",
  "block.minecraft.grindstone": "Köszörűkő",
  "block.minecraft.hanging_roots": "Lógó gyökerek",
  "block.minecraft.hay_block": "Szalmabála",
  "block.minecraft.heavy_core": "Nehéz mag",
  "block.minecraft.heavy_weighted_pressure_plate": "Nehéz súlymérő nyomólap",
  "block.minecraft.honey_block": "Mézblokk",
  "block.minecraft.honeycomb_block": "Méhsejtblokk",
  "block.minecraft.hopper": "Tölcsér",
  "block.minecraft.horn_coral": "Agancskorall",
  "block.minecraft.horn_coral_block": "Agancskorall-blokk",
  "block.minecraft.horn_coral_fan": "Agancskorall-legyező",
  "block.minecraft.horn_coral_wall_fan": "Fali agancskorall-legyező",
  "block.minecraft.ice": "Jég",
  "block.minecraft.infested_chiseled_stone_bricks": "Vésett kőtégla ezüstmollyal",
  "block.minecraft.infested_cobblestone": "Zúzottkő ezüstmollyal",
  "block.minecraft.infested_cracked_stone_bricks": "Repedt kőtégla ezüstmollyal",
  "block.minecraft.infested_deepslate": "Mélypala ezüstmollyal",
  "block.minecraft.infested_mossy_stone_bricks": "Mohás kőtégla ezüstmollyal",
  "block.minecraft.infested_stone": "Kő ezüstmollyal",
  "block.minecraft.infested_stone_bricks": "Kőtégla ezüstmollyal",
  "block.minecraft.iron_bars": "Vasrács",
  "block.minecraft.iron_block": "Vasblokk",
  "block.minecraft.iron_chain": "Vaslánc",
  "block.minecraft.iron_door": "Vasajtó",
  "block.minecraft.iron_ore": "Vasérc",
  "block.minecraft.iron_trapdoor": "Vas csapóajtó",
  "block.minecraft.jack_o_lantern": "Töklámpás",
  "block.minecraft.jigsaw": "Kirakósblokk",
  "block.minecraft.jukebox": "Zenegép",
  "block.minecraft.jungle_button": "Dzsungelfa gomb",
  "block.minecraft.jungle_door": "Dzsungelfa ajtó",
  "block.minecraft.jungle_fence": "Dzsungelfa kerítés",
  "block.minecraft.jungle_fence_gate": "Dzsungelfa kerítéskapu",
  "block.minecraft.jungle_hanging_sign": "Dzsungelfa függőtábla",
  "block.minecraft.jungle_leaves": "Dzsungelfalevelek",
  "block.minecraft.jungle_log": "Dzsungelfarönk",
  "block.minecraft.jungle_planks": "Dzsungelfa deszka",
  "block.minecraft.jungle_pressure_plate": "Dzsungelfa nyomólap",
  "block.minecraft.jungle_sapling": "Dzsungelfacsemete",
  "block.minecraft.jungle_shelf": "Dzsungelfa polc",
  "block.minecraft.jungle_sign": "Dzsungelfa tábla",
  "block.minecraft.jungle_slab": "Dzsungelfa lap",
  "block.minecraft.jungle_stairs": "Dzsungelfa lépcső",
  "block.minecraft.jungle_trapdoor": "Dzsungelfa csapóajtó",
  "block.minecraft.jungle_wall_hanging_sign": "Dzsungelfa fali függőtábla",
  "block.minecraft.jungle_wall_sign": "Dzsungelfa falitábla",
  "block.minecraft.jungle_wood": "Dzsungelfablokk",
  "block.minecraft.kelp": "Hínár",
  "block.minecraft.kelp_plant": "Hínárszár",
  "block.minecraft.ladder": "Létra",
  "block.minecraft.lantern": "Lámpás",
  "block.minecraft.lapis_block": "Lazuritblokk",
  "block.minecraft.lapis_ore": "Lazuritérc",
  "block.minecraft.large_amethyst_bud": "Nagy ametisztkristály",
  "block.minecraft.large_fern": "Nagy páfrány",
  "block.minecraft.lava": "Láva",
  "block.minecraft.lava_cauldron": "Lávával teli üst",
  "block.minecraft.leaf_litter": "Avar",
  "block.minecraft.lectern": "Olvasóállvány",
  "block.minecraft.lever": "Kar",
  "block.minecraft.light": "Fény",
  "block.minecraft.light_blue_banner": "Világoskék zászló",
  "block.minecraft.light_blue_bed": "Világoskék ágy",
  "block.minecraft.light_blue_candle": "Világoskék gyertya",
  "block.minecraft.light_blue_candle_cake": "Torta világoskék gyertyával",
  "block.minecraft.light_blue_carpet": "Világoskék szőnyeg",
  "block.minecraft.light_blue_concrete": "Világoskék beton",
  "block.minecraft.light_blue_concrete_powder": "Világoskék szárazbeton",
  "block.minecraft.light_blue_glazed_terracotta": "Világoskék mázas kerámia",
  "block.minecraft.light_blue_shulker_box": "Világoskék shulkerdoboz",
  "block.minecraft.light_blue_stained_glass": "Világoskék festett üveg",
  "block.minecraft.light_blue_stained_glass_pane": "Világoskék festett üveglap",
  "block.minecraft.light_blue_terracotta": "Világoskék terrakotta",
  "block.minecraft.light_blue_wool": "Világoskék gyapjú",
  "block.minecraft.light_gray_banner": "Világosszürke zászló",
  "block.minecraft.light_gray_bed": "Világosszürke ágy",
  "block.minecraft.light_gray_candle": "Világosszürke gyertya",
  "block.minecraft.light_gray_candle_cake": "Torta világosszürke gyertyával",
  "block.minecraft.light_gray_carpet": "Világosszürke szőnyeg",
  "block.minecraft.light_gray_concrete": "Világosszürke beton",
  "block.minecraft.light_gray_concrete_powder": "Világosszürke szárazbeton",
  "block.minecraft.light_gray_glazed_terracotta": "Világosszürke mázas kerámia",
  "block.minecraft.light_gray_shulker_box": "Világosszürke shulkerdoboz",
  "block.minecraft.light_gray_stained_glass": "Világosszürke festett üveg",
  "block.minecraft.light_gray_stained_glass_pane": "Világosszürke festett üveglap",
  "block.minecraft.light_gray_terracotta": "Világosszürke terrakotta",
  "block.minecraft.light_gray_wool": "Világosszürke gyapjú",
  "block.minecraft.light_weighted_pressure_plate": "Könnyű súlymérő nyomólap",
  "block.minecraft.lightning_rod": "Villámhárító",
  "block.minecraft.lilac": "Orgona",
  "block.minecraft.lily_of_the_valley": "Gyöngyvirág",
  "block.minecraft.lily_pad": "Tavirózsa",
  "block.minecraft.lime_banner": "Világoszöld zászló",
  "block.minecraft.lime_bed": "Világoszöld ágy",
  "block.minecraft.lime_candle": "Világoszöld gyertya",
  "block.minecraft.lime_candle_cake": "Torta világoszöld gyertyával",
  "block.minecraft.lime_carpet": "Világoszöld szőnyeg",
  "block.minecraft.lime_concrete": "Világoszöld beton",
  "block.minecraft.lime_concrete_powder": "Világoszöld szárazbeton",
  "block.minecraft.lime_glazed_terracotta": "Világoszöld mázas kerámia",
  "block.minecraft.lime_shulker_box": "Világoszöld shulkerdoboz",
  "block.minecraft.lime_stained_glass": "Világoszöld festett üveg",
  "block.minecraft.lime_stained_glass_pane": "Világoszöld festett üveglap",
  "block.minecraft.lime_terracotta": "Világoszöld terrakotta",
  "block.minecraft.lime_wool": "Világoszöld gyapjú",
  "block.minecraft.lodestone": "Iránykő",
  "block.minecraft.loom": "Szövőszék",
  "block.minecraft.magenta_banner": "Bíbor zászló",
  "block.minecraft.magenta_bed": "Bíbor ágy",
  "block.minecraft.magenta_candle": "Bíbor gyertya",
  "block.minecraft.magenta_candle_cake": "Torta bíbor gyertyával",
  "block.minecraft.magenta_carpet": "Bíbor szőnyeg",
  "block.minecraft.magenta_concrete": "Bíbor beton",
  "block.minecraft.magenta_concrete_powder": "Bíbor szárazbeton",
  "block.minecraft.magenta_glazed_terracotta": "Bíbor mázas kerámia",
  "block.minecraft.magenta_shulker_box": "Bíbor shulkerdoboz",
  "block.minecraft.magenta_stained_glass": "Bíbor festett üveg",
  "block.minecraft.magenta_stained_glass_pane": "Bíbor festett üveglap",
  "block.minecraft.magenta_terracotta": "Bíbor terrakotta",
  "block.minecraft.magenta_wool": "Bíbor gyapjú",
  "block.minecraft.magma_block": "Magmablokk",
  "block.minecraft.mangrove_button": "Mangrovefa gomb",
  "block.minecraft.mangrove_door": "Mangrovefa ajtó",
  "block.minecraft.mangrove_fence": "Mangrovefa kerítés",
  "block.minecraft.mangrove_fence_gate": "Mangrovefa kerítéskapu",
  "block.minecraft.mangrove_hanging_sign": "Mangrovefa függőtábla",
  "block.minecraft.mangrove_leaves": "Mangrovelevelek",
  "block.minecraft.mangrove_log": "Mangroverönk",
  "block.minecraft.mangrove_planks": "Mangrovedeszka",
  "block.minecraft.mangrove_pressure_plate": "Mangrovefa nyomólap",
  "block.minecraft.mangrove_propagule": "Mangrovemagonc",
  "block.minecraft.mangrove_roots": "Mangrovegyökerek",
  "block.minecraft.mangrove_shelf": "Mangrovefa polc",
  "block.minecraft.mangrove_sign": "Mangrovefa tábla",
  "block.minecraft.mangrove_slab": "Mangrovefa lap",
  "block.minecraft.mangrove_stairs": "Mangrovefa lépcső",
  "block.minecraft.mangrove_trapdoor": "Mangrovefa csapóajtó",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovefa fali függőtábla",
  "block.minecraft.mangrove_wall_sign": "Mangrovefa falitábla",
  "block.minecraft.mangrove_wood": "Mangroveblokk",
  "block.minecraft.medium_amethyst_bud": "Közepes ametisztkristály",
  "block.minecraft.melon": "Dinnye",
  "block.minecraft.melon_stem": "Dinnyeszár",
  "block.minecraft.moss_block": "Mohablokk",
  "block.minecraft.moss_carpet": "Mohaszőnyeg",
  "block.minecraft.mossy_cobblestone": "Mohás zúzottkő",
  "block.minecraft.mossy_cobblestone_slab": "Mohás zúzottkő lap",
  "block.minecraft.mossy_cobblestone_stairs": "Mohás zúzottkőlépcső",
  "block.minecraft.mossy_cobblestone_wall": "Mohás zúzottkő-fal",
  "block.minecraft.mossy_stone_brick_slab": "Mohás kőtégla lap",
  "block.minecraft.mossy_stone_brick_stairs": "Mohás kőtégla-lépcső",
  "block.minecraft.mossy_stone_brick_wall": "Mohás kőtéglafal",
  "block.minecraft.mossy_stone_bricks": "Mohás kőtégla",
  "block.minecraft.moving_piston": "Mozgó dugattyú",
  "block.minecraft.mud": "Iszap",
  "block.minecraft.mud_brick_slab": "Vályogtégla lap",
  "block.minecraft.mud_brick_stairs": "Vályogtégla-lépcső",
  "block.minecraft.mud_brick_wall": "Vályogtégla-fal",
  "block.minecraft.mud_bricks": "Vályogtégla",
  "block.minecraft.muddy_mangrove_roots": "Iszapos mangrovegyökerek",
  "block.minecraft.mushroom_stem": "Gombatönk",
  "block.minecraft.mycelium": "Micélium",
  "block.minecraft.nether_brick_fence": "Nethertégla-kerítés",
  "block.minecraft.nether_brick_slab": "Nethertégla lap",
  "block.minecraft.nether_brick_stairs": "Nethertégla-lépcső",
  "block.minecraft.nether_brick_wall": "Nethertégla-fal",
  "block.minecraft.nether_bricks": "Nethertégla",
  "block.minecraft.nether_gold_ore": "Netheraranyérc",
  "block.minecraft.nether_portal": "Nether-portál",
  "block.minecraft.nether_quartz_ore": "Netherkvarcérc",
  "block.minecraft.nether_sprouts": "Nethercsírák",
  "block.minecraft.nether_wart": "Netherbibircsók",
  "block.minecraft.nether_wart_block": "Netherbibircsók-blokk",
  "block.minecraft.netherite_block": "Netheritblokk",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Hangdoboz",
  "block.minecraft.oak_button": "Tölgyfa gomb",
  "block.minecraft.oak_door": "Tölgyfa ajtó",
  "block.minecraft.oak_fence": "Tölgyfa kerítés",
  "block.minecraft.oak_fence_gate": "Tölgyfa kerítéskapu",
  "block.minecraft.oak_hanging_sign": "Tölgyfa függőtábla",
  "block.minecraft.oak_leaves": "Tölgylevelek",
  "block.minecraft.oak_log": "Tölgyfarönk",
  "block.minecraft.oak_planks": "Tölgydeszka",
  "block.minecraft.oak_pressure_plate": "Tölgyfa nyomólap",
  "block.minecraft.oak_sapling": "Tölgycsemete",
  "block.minecraft.oak_shelf": "Tölgyfa polc",
  "block.minecraft.oak_sign": "Tölgyfa tábla",
  "block.minecraft.oak_slab": "Tölgyfa lap",
  "block.minecraft.oak_stairs": "Tölgyfa lépcső",
  "block.minecraft.oak_trapdoor": "Tölgyfa csapóajtó",
  "block.minecraft.oak_wall_hanging_sign": "Tölgyfa fali függőtábla",
  "block.minecraft.oak_wall_sign": "Tölgyfa falitábla",
  "block.minecraft.oak_wood": "Tölgyfablokk",
  "block.minecraft.observer": "Megfigyelő",
  "block.minecraft.obsidian": "Obszidián",
  "block.minecraft.ochre_froglight": "Okker varangyfény",
  "block.minecraft.ominous_banner": "Vészjósló zászló",
  "block.minecraft.open_eyeblossom": "Nyitott szemvirág",
  "block.minecraft.orange_banner": "Narancssárga zászló",
  "block.minecraft.orange_bed": "Narancssárga ágy",
  "block.minecraft.orange_candle": "Narancssárga gyertya",
  "block.minecraft.orange_candle_cake": "Torta narancssárga gyertyával",
  "block.minecraft.orange_carpet": "Narancssárga szőnyeg",
  "block.minecraft.orange_concrete": "Narancssárga beton",
  "block.minecraft.orange_concrete_powder": "Narancssárga szárazbeton",
  "block.minecraft.orange_glazed_terracotta": "Narancssárga mázas kerámia",
  "block.minecraft.orange_shulker_box": "Narancssárga shulkerdoboz",
  "block.minecraft.orange_stained_glass": "Narancssárga festett üveg",
  "block.minecraft.orange_stained_glass_pane": "Narancssárga festett üveglap",
  "block.minecraft.orange_terracotta": "Narancssárga terrakotta",
  "block.minecraft.orange_tulip": "Narancssárga tulipán",
  "block.minecraft.orange_wool": "Narancssárga gyapjú",
  "block.minecraft.oxeye_daisy": "Margaréta",
  "block.minecraft.oxidized_chiseled_copper": "Patinás vésett rézblokk",
  "block.minecraft.oxidized_copper": "Patinás rézblokk",
  "block.minecraft.oxidized_copper_bars": "Patinás rézrács",
  "block.minecraft.oxidized_copper_bulb": "Patinás rézizzó",
  "block.minecraft.oxidized_copper_chain": "Patinás rézlánc",
  "block.minecraft.oxidized_copper_chest": "Patinás rézláda",
  "block.minecraft.oxidized_copper_door": "Patinás rézajtó",
  "block.minecraft.oxidized_copper_golem_statue": "Patinás rézgólem-szobor",
  "block.minecraft.oxidized_copper_grate": "Patinás rézrostély",
  "block.minecraft.oxidized_copper_lantern": "Patinás rézlámpás",
  "block.minecraft.oxidized_copper_trapdoor": "Patinás réz csapóajtó",
  "block.minecraft.oxidized_cut_copper": "Patinás vágott rézblokk",
  "block.minecraft.oxidized_cut_copper_slab": "Patinás vágott rézlap",
  "block.minecraft.oxidized_cut_copper_stairs": "Patinás vágott rézlépcső",
  "block.minecraft.oxidized_lightning_rod": "Patinás villámhárító",
  "block.minecraft.packed_ice": "Tömör jég",
  "block.minecraft.packed_mud": "Vályog",
  "block.minecraft.pale_hanging_moss": "Lógó fátyolmoha",
  "block.minecraft.pale_moss_block": "Fátyolmoha-blokk",
  "block.minecraft.pale_moss_carpet": "Fátyolmoha-szőnyeg",
  "block.minecraft.pale_oak_button": "Sápadttölgy gomb",
  "block.minecraft.pale_oak_door": "Sápadttölgy ajtó",
  "block.minecraft.pale_oak_fence": "Sápadttölgy kerítés",
  "block.minecraft.pale_oak_fence_gate": "Sápadttölgy kerítéskapu",
  "block.minecraft.pale_oak_hanging_sign": "Sápadttölgy függőtábla",
  "block.minecraft.pale_oak_leaves": "Sápadttölgy-levelek",
  "block.minecraft.pale_oak_log": "Sápadttölgy-rönk",
  "block.minecraft.pale_oak_planks": "Sápadttölgy deszka",
  "block.minecraft.pale_oak_pressure_plate": "Sápadttölgy nyomólap",
  "block.minecraft.pale_oak_sapling": "Sápadttölgy csemete",
  "block.minecraft.pale_oak_shelf": "Sápadttölgy polc",
  "block.minecraft.pale_oak_sign": "Sápadttölgy tábla",
  "block.minecraft.pale_oak_slab": "Sápadttölgy lap",
  "block.minecraft.pale_oak_stairs": "Sápadttölgy lépcső",
  "block.minecraft.pale_oak_trapdoor": "Sápadttölgy csapóajtó",
  "block.minecraft.pale_oak_wall_hanging_sign": "Sápadttölgy fali függőtábla",
  "block.minecraft.pale_oak_wall_sign": "Sápadttölgy falitábla",
  "block.minecraft.pale_oak_wood": "Sápadttölgyblokk",
  "block.minecraft.pearlescent_froglight": "Gyöngyházfényű varangyfény",
  "block.minecraft.peony": "Bazsarózsa",
  "block.minecraft.petrified_oak_slab": "Megkövült tölgyfa lap",
  "block.minecraft.piglin_head": "Piglinfej",
  "block.minecraft.piglin_wall_head": "Fali piglinfej",
  "block.minecraft.pink_banner": "Rózsaszín zászló",
  "block.minecraft.pink_bed": "Rózsaszín ágy",
  "block.minecraft.pink_candle": "Rózsaszín gyertya",
  "block.minecraft.pink_candle_cake": "Torta rózsaszín gyertyával",
  "block.minecraft.pink_carpet": "Rózsaszín szőnyeg",
  "block.minecraft.pink_concrete": "Rózsaszín beton",
  "block.minecraft.pink_concrete_powder": "Rózsaszín szárazbeton",
  "block.minecraft.pink_glazed_terracotta": "Rózsaszín mázas kerámia",
  "block.minecraft.pink_petals": "Rózsaszín szirmok",
  "block.minecraft.pink_shulker_box": "Rózsaszín shulkerdoboz",
  "block.minecraft.pink_stained_glass": "Rózsaszín festett üveg",
  "block.minecraft.pink_stained_glass_pane": "Rózsaszín festett üveglap",
  "block.minecraft.pink_terracotta": "Rózsaszín terrakotta",
  "block.minecraft.pink_tulip": "Rózsaszín tulipán",
  "block.minecraft.pink_wool": "Rózsaszín gyapjú",
  "block.minecraft.piston": "Dugattyú",
  "block.minecraft.piston_head": "Dugattyúfej",
  "block.minecraft.pitcher_crop": "Kancsókahüvely",
  "block.minecraft.pitcher_plant": "Kancsókanövény",
  "block.minecraft.player_head": "Játékosfej",
  "block.minecraft.player_head.named": "%s feje",
  "block.minecraft.player_wall_head": "Fali játékosfej",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Hegyes cseppkő",
  "block.minecraft.polished_andesite": "Csiszolt andezit",
  "block.minecraft.polished_andesite_slab": "Csiszolt andezitlap",
  "block.minecraft.polished_andesite_stairs": "Csiszolt andezitlépcső",
  "block.minecraft.polished_basalt": "Csiszolt bazalt",
  "block.minecraft.polished_blackstone": "Csiszolt feketekő",
  "block.minecraft.polished_blackstone_brick_slab": "Csiszolt feketekőtégla lap",
  "block.minecraft.polished_blackstone_brick_stairs": "Csiszolt feketekőtégla-lépcső",
  "block.minecraft.polished_blackstone_brick_wall": "Csiszolt feketekőtégla-fal",
  "block.minecraft.polished_blackstone_bricks": "Csiszolt feketekőtégla",
  "block.minecraft.polished_blackstone_button": "Csiszolt feketekő gomb",
  "block.minecraft.polished_blackstone_pressure_plate": "Csiszolt feketekő nyomólap",
  "block.minecraft.polished_blackstone_slab": "Csiszolt feketekő lap",
  "block.minecraft.polished_blackstone_stairs": "Csiszolt feketekő lépcső",
  "block.minecraft.polished_blackstone_wall": "Csiszolt feketekő fal",
  "block.minecraft.polished_deepslate": "Csiszolt mélypala",
  "block.minecraft.polished_deepslate_slab": "Csiszolt mélypala lap",
  "block.minecraft.polished_deepslate_stairs": "Csiszolt mélypala lépcső",
  "block.minecraft.polished_deepslate_wall": "Csiszolt mélypala fal",
  "block.minecraft.polished_diorite": "Csiszolt diorit",
  "block.minecraft.polished_diorite_slab": "Csiszolt dioritlap",
  "block.minecraft.polished_diorite_stairs": "Csiszolt dioritlépcső",
  "block.minecraft.polished_granite": "Csiszolt gránit",
  "block.minecraft.polished_granite_slab": "Csiszolt gránitlap",
  "block.minecraft.polished_granite_stairs": "Csiszolt gránitlépcső",
  "block.minecraft.polished_tuff": "Csiszolt tufa",
  "block.minecraft.polished_tuff_slab": "Csiszolt tufalap",
  "block.minecraft.polished_tuff_stairs": "Csiszolt tufalépcső",
  "block.minecraft.polished_tuff_wall": "Csiszolt tufafal",
  "block.minecraft.poppy": "Pipacs",
  "block.minecraft.potatoes": "Burgonyák",
  "block.minecraft.potted_acacia_sapling": "Akáciacsemete cserépben",
  "block.minecraft.potted_allium": "Hagymavirág cserépben",
  "block.minecraft.potted_azalea_bush": "Azálea cserépben",
  "block.minecraft.potted_azure_bluet": "Kékpárna cserépben",
  "block.minecraft.potted_bamboo": "Bambusz cserépben",
  "block.minecraft.potted_birch_sapling": "Nyírfacsemete cserépben",
  "block.minecraft.potted_blue_orchid": "Kék orchidea cserépben",
  "block.minecraft.potted_brown_mushroom": "Barna gomba cserépben",
  "block.minecraft.potted_cactus": "Kaktusz cserépben",
  "block.minecraft.potted_cherry_sapling": "Cseresznyefa-csemete cserépben",
  "block.minecraft.potted_closed_eyeblossom": "Zárt szemvirág cserépben",
  "block.minecraft.potted_cornflower": "Búzavirág cserépben",
  "block.minecraft.potted_crimson_fungus": "Karmazsin gomba cserépben",
  "block.minecraft.potted_crimson_roots": "Karmazsin gyökerek cserépben",
  "block.minecraft.potted_dandelion": "Pitypang cserépben",
  "block.minecraft.potted_dark_oak_sapling": "Sötéttölgy-csemete cserépben",
  "block.minecraft.potted_dead_bush": "Száraz kóró cserépben",
  "block.minecraft.potted_fern": "Páfrány cserépben",
  "block.minecraft.potted_flowering_azalea_bush": "Virágzó azálea cserépben",
  "block.minecraft.potted_golden_dandelion": "Aranypitypang cserépben",
  "block.minecraft.potted_jungle_sapling": "Dzsungelfacsemete cserépben",
  "block.minecraft.potted_lily_of_the_valley": "Gyöngyvirág cserépben",
  "block.minecraft.potted_mangrove_propagule": "Mangrovemagonc cserépben",
  "block.minecraft.potted_oak_sapling": "Tölgycsemete cserépben",
  "block.minecraft.potted_open_eyeblossom": "Nyitott szemvirág cserépben",
  "block.minecraft.potted_orange_tulip": "Narancssárga tulipán cserépben",
  "block.minecraft.potted_oxeye_daisy": "Margaréta cserépben",
  "block.minecraft.potted_pale_oak_sapling": "Sápadttölgy-csemete cserépben",
  "block.minecraft.potted_pink_tulip": "Rózsaszín tulipán cserépben",
  "block.minecraft.potted_poppy": "Pipacs cserépben",
  "block.minecraft.potted_red_mushroom": "Piros gomba cserépben",
  "block.minecraft.potted_red_tulip": "Piros tulipán cserépben",
  "block.minecraft.potted_spruce_sapling": "Fenyőcsemete cserépben",
  "block.minecraft.potted_torchflower": "Fáklyaliliom cserépben",
  "block.minecraft.potted_warped_fungus": "Torz gomba cserépben",
  "block.minecraft.potted_warped_roots": "Torz gyökerek cserépben",
  "block.minecraft.potted_white_tulip": "Fehér tulipán cserépben",
  "block.minecraft.potted_wither_rose": "Witherrózsa cserépben",
  "block.minecraft.powder_snow": "Porhó",
  "block.minecraft.powder_snow_cauldron": "Porhóval teli üst",
  "block.minecraft.powered_rail": "Gyorsítósín",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarintégla lap",
  "block.minecraft.prismarine_brick_stairs": "Prizmarintégla lépcső",
  "block.minecraft.prismarine_bricks": "Prizmarintégla",
  "block.minecraft.prismarine_slab": "Prizmarinlap",
  "block.minecraft.prismarine_stairs": "Prizmarinlépcső",
  "block.minecraft.prismarine_wall": "Prizmarinfal",
  "block.minecraft.pumpkin": "Tök",
  "block.minecraft.pumpkin_stem": "Tökszár",
  "block.minecraft.purple_banner": "Lila zászló",
  "block.minecraft.purple_bed": "Lila ágy",
  "block.minecraft.purple_candle": "Lila gyertya",
  "block.minecraft.purple_candle_cake": "Torta lila gyertyával",
  "block.minecraft.purple_carpet": "Lila szőnyeg",
  "block.minecraft.purple_concrete": "Lila beton",
  "block.minecraft.purple_concrete_powder": "Lila szárazbeton",
  "block.minecraft.purple_glazed_terracotta": "Lila mázas kerámia",
  "block.minecraft.purple_shulker_box": "Lila shulkerdoboz",
  "block.minecraft.purple_stained_glass": "Lila festett üveg",
  "block.minecraft.purple_stained_glass_pane": "Lila festett üveglap",
  "block.minecraft.purple_terracotta": "Lila terrakotta",
  "block.minecraft.purple_wool": "Lila gyapjú",
  "block.minecraft.purpur_block": "Purpurblokk",
  "block.minecraft.purpur_pillar": "Purpuroszlop",
  "block.minecraft.purpur_slab": "Purpurlap",
  "block.minecraft.purpur_stairs": "Purpurlépcső",
  "block.minecraft.quartz_block": "Kvarcblokk",
  "block.minecraft.quartz_bricks": "Kvarctégla",
  "block.minecraft.quartz_pillar": "Kvarcoszlop",
  "block.minecraft.quartz_slab": "Kvarclap",
  "block.minecraft.quartz_stairs": "Kvarclépcső",
  "block.minecraft.rail": "Sín",
  "block.minecraft.raw_copper_block": "Nyersrézblokk",
  "block.minecraft.raw_gold_block": "Nyersaranyblokk",
  "block.minecraft.raw_iron_block": "Nyersvasblokk",
  "block.minecraft.red_banner": "Vörös zászló",
  "block.minecraft.red_bed": "Vörös ágy",
  "block.minecraft.red_candle": "Vörös gyertya",
  "block.minecraft.red_candle_cake": "Torta vörös gyertyával",
  "block.minecraft.red_carpet": "Vörös szőnyeg",
  "block.minecraft.red_concrete": "Vörös beton",
  "block.minecraft.red_concrete_powder": "Vörös szárazbeton",
  "block.minecraft.red_glazed_terracotta": "Vörös mázas kerámia",
  "block.minecraft.red_mushroom": "Piros gomba",
  "block.minecraft.red_mushroom_block": "Piros gombablokk",
  "block.minecraft.red_nether_brick_slab": "Vörös nethertégla lap",
  "block.minecraft.red_nether_brick_stairs": "Vörös nethertégla-lépcső",
  "block.minecraft.red_nether_brick_wall": "Vörös nethertégla-fal",
  "block.minecraft.red_nether_bricks": "Vörös nethertégla",
  "block.minecraft.red_sand": "Vörös homok",
  "block.minecraft.red_sandstone": "Vörös homokkő",
  "block.minecraft.red_sandstone_slab": "Vörös homokkő lap",
  "block.minecraft.red_sandstone_stairs": "Vörös homokkő lépcső",
  "block.minecraft.red_sandstone_wall": "Vörös homokkő fal",
  "block.minecraft.red_shulker_box": "Vörös shulkerdoboz",
  "block.minecraft.red_stained_glass": "Vörös festett üveg",
  "block.minecraft.red_stained_glass_pane": "Vörös festett üveglap",
  "block.minecraft.red_terracotta": "Vörös terrakotta",
  "block.minecraft.red_tulip": "Piros tulipán",
  "block.minecraft.red_wool": "Vörös gyapjú",
  "block.minecraft.redstone_block": "Redstone-blokk",
  "block.minecraft.redstone_lamp": "Redstone-lámpa",
  "block.minecraft.redstone_ore": "Redstone-érc",
  "block.minecraft.redstone_torch": "Redstone-fáklya",
  "block.minecraft.redstone_wall_torch": "Fali redstone-fáklya",
  "block.minecraft.redstone_wire": "Redstone-vezeték",
  "block.minecraft.reinforced_deepslate": "Megerősített mélypala",
  "block.minecraft.repeater": "Redstone-jelismétlő",
  "block.minecraft.repeating_command_block": "Ismétlő parancsblokk",
  "block.minecraft.resin_block": "Gyantablokk",
  "block.minecraft.resin_brick_slab": "Gyantatégla lap",
  "block.minecraft.resin_brick_stairs": "Gyantatégla lépcső",
  "block.minecraft.resin_brick_wall": "Gyantatégla-fal",
  "block.minecraft.resin_bricks": "Gyantatégla",
  "block.minecraft.resin_clump": "Gyantadarab",
  "block.minecraft.respawn_anchor": "Újraéledés-kapocs",
  "block.minecraft.rooted_dirt": "Gyökeres föld",
  "block.minecraft.rose_bush": "Rózsabokor",
  "block.minecraft.sand": "Homok",
  "block.minecraft.sandstone": "Homokkő",
  "block.minecraft.sandstone_slab": "Homokkő lap",
  "block.minecraft.sandstone_stairs": "Homokkő lépcső",
  "block.minecraft.sandstone_wall": "Homokkő fal",
  "block.minecraft.scaffolding": "Állványzat",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkgerjesztő",
  "block.minecraft.sculk_sensor": "Sculkérzékelő",
  "block.minecraft.sculk_shrieker": "Sculksikoltó",
  "block.minecraft.sculk_vein": "Sculkvéna",
  "block.minecraft.sea_lantern": "Tengeri lámpás",
  "block.minecraft.sea_pickle": "Világító zsákállat",
  "block.minecraft.seagrass": "Tengerifű",
  "block.minecraft.set_spawn": "Újraéledési pont beállítva",
  "block.minecraft.short_dry_grass": "Rövid száraz fű",
  "block.minecraft.short_grass": "Alacsony fű",
  "block.minecraft.shroomlight": "Fényspóra",
  "block.minecraft.shulker_box": "Shulkerdoboz",
  "block.minecraft.skeleton_skull": "Csontvázkoponya",
  "block.minecraft.skeleton_wall_skull": "Fali csontvázkoponya",
  "block.minecraft.slime_block": "Nyálkablokk",
  "block.minecraft.small_amethyst_bud": "Kis ametisztkristály",
  "block.minecraft.small_dripleaf": "Kis csepplevél",
  "block.minecraft.smithing_table": "Kovácsasztal",
  "block.minecraft.smoker": "Füstölő",
  "block.minecraft.smooth_basalt": "Sima bazalt",
  "block.minecraft.smooth_quartz": "Csiszolt kvarcblokk",
  "block.minecraft.smooth_quartz_slab": "Csiszolt kvarclap",
  "block.minecraft.smooth_quartz_stairs": "Csiszolt kvarclépcső",
  "block.minecraft.smooth_red_sandstone": "Csiszolt vörös homokkő",
  "block.minecraft.smooth_red_sandstone_slab": "Csiszolt vörös homokkő lap",
  "block.minecraft.smooth_red_sandstone_stairs": "Csiszolt vörös homokkő lépcső",
  "block.minecraft.smooth_sandstone": "Csiszolt homokkő",
  "block.minecraft.smooth_sandstone_slab": "Csiszolt homokkő lap",
  "block.minecraft.smooth_sandstone_stairs": "Csiszolt homokkő lépcső",
  "block.minecraft.smooth_stone": "Csiszolt kő",
  "block.minecraft.smooth_stone_slab": "Csiszolt kőlap",
  "block.minecraft.sniffer_egg": "Orrontótojás",
  "block.minecraft.snow": "Hó",
  "block.minecraft.snow_block": "Hóblokk",
  "block.minecraft.soul_campfire": "Lélektábortűz",
  "block.minecraft.soul_fire": "Lélektűz",
  "block.minecraft.soul_lantern": "Léleklámpás",
  "block.minecraft.soul_sand": "Lélekhomok",
  "block.minecraft.soul_soil": "Lélektalaj",
  "block.minecraft.soul_torch": "Lélekfáklya",
  "block.minecraft.soul_wall_torch": "Fali lélekfáklya",
  "block.minecraft.spawn.not_valid": "Nincs ágyad vagy egy feltöltött újraéledés-kapcsod, vagy nem használható",
  "block.minecraft.spawner": "Idézőketrec",
  "block.minecraft.spawner.desc1": "Interakció idézőtojással:",
  "block.minecraft.spawner.desc2": "Beállítja a mob típusát",
  "block.minecraft.sponge": "Szivacs",
  "block.minecraft.spore_blossom": "Spóravirág",
  "block.minecraft.spruce_button": "Fenyőfa gomb",
  "block.minecraft.spruce_door": "Fenyőfa ajtó",
  "block.minecraft.spruce_fence": "Fenyőfa kerítés",
  "block.minecraft.spruce_fence_gate": "Fenyőfa kerítéskapu",
  "block.minecraft.spruce_hanging_sign": "Fenyőfa függőtábla",
  "block.minecraft.spruce_leaves": "Fenyőlevelek",
  "block.minecraft.spruce_log": "Fenyőrönk",
  "block.minecraft.spruce_planks": "Fenyődeszka",
  "block.minecraft.spruce_pressure_plate": "Fenyőfa nyomólap",
  "block.minecraft.spruce_sapling": "Fenyőcsemete",
  "block.minecraft.spruce_shelf": "Fenyőfa polc",
  "block.minecraft.spruce_sign": "Fenyőtábla",
  "block.minecraft.spruce_slab": "Fenyőfa lap",
  "block.minecraft.spruce_stairs": "Fenyőfa lépcső",
  "block.minecraft.spruce_trapdoor": "Fenyőfa csapóajtó",
  "block.minecraft.spruce_wall_hanging_sign": "Fenyőfa fali függőtábla",
  "block.minecraft.spruce_wall_sign": "Fenyőfa falitábla",
  "block.minecraft.spruce_wood": "Fenyőblokk",
  "block.minecraft.sticky_piston": "Ragacsos dugattyú",
  "block.minecraft.stone": "Kő",
  "block.minecraft.stone_brick_slab": "Kőtégla lap",
  "block.minecraft.stone_brick_stairs": "Kőtégla-lépcső",
  "block.minecraft.stone_brick_wall": "Kőtéglafal",
  "block.minecraft.stone_bricks": "Kőtégla",
  "block.minecraft.stone_button": "Kőgomb",
  "block.minecraft.stone_pressure_plate": "Kő nyomólap",
  "block.minecraft.stone_slab": "Kőlap",
  "block.minecraft.stone_stairs": "Kőlépcső",
  "block.minecraft.stonecutter": "Kővágó",
  "block.minecraft.stripped_acacia_log": "Kérgezett akáciarönk",
  "block.minecraft.stripped_acacia_wood": "Kérgezett akáciablokk",
  "block.minecraft.stripped_bamboo_block": "Kérgezett bambuszblokk",
  "block.minecraft.stripped_birch_log": "Kérgezett nyírfarönk",
  "block.minecraft.stripped_birch_wood": "Kérgezett nyírfablokk",
  "block.minecraft.stripped_cherry_log": "Kérgezett cseresznyefarönk",
  "block.minecraft.stripped_cherry_wood": "Kérgezett cseresznyefablokk",
  "block.minecraft.stripped_crimson_hyphae": "Kérgezett karmazsin gombafonalak",
  "block.minecraft.stripped_crimson_stem": "Kérgezett karmazsin tönk",
  "block.minecraft.stripped_dark_oak_log": "Kérgezett sötéttölgy-rönk",
  "block.minecraft.stripped_dark_oak_wood": "Kérgezett sötéttölgyblokk",
  "block.minecraft.stripped_jungle_log": "Kérgezett dzsungelfarönk",
  "block.minecraft.stripped_jungle_wood": "Kérgezett dzsungelfablokk",
  "block.minecraft.stripped_mangrove_log": "Kérgezett mangroverönk",
  "block.minecraft.stripped_mangrove_wood": "Kérgezett mangroveblokk",
  "block.minecraft.stripped_oak_log": "Kérgezett tölgyfarönk",
  "block.minecraft.stripped_oak_wood": "Kérgezett tölgyfablokk",
  "block.minecraft.stripped_pale_oak_log": "Kérgezett sápadttölgy-rönk",
  "block.minecraft.stripped_pale_oak_wood": "Kérgezett sápadttölgyblokk",
  "block.minecraft.stripped_spruce_log": "Kérgezett fenyőrönk",
  "block.minecraft.stripped_spruce_wood": "Kérgezett fenyőblokk",
  "block.minecraft.stripped_warped_hyphae": "Kérgezett torz gombafonalak",
  "block.minecraft.stripped_warped_stem": "Kérgezett torz tönk",
  "block.minecraft.structure_block": "Struktúrablokk",
  "block.minecraft.structure_void": "Struktúraűr",
  "block.minecraft.sugar_cane": "Cukornád",
  "block.minecraft.sunflower": "Napraforgó",
  "block.minecraft.suspicious_gravel": "Gyanús sóder",
  "block.minecraft.suspicious_sand": "Gyanús homok",
  "block.minecraft.sweet_berry_bush": "Édesbogyóbokor",
  "block.minecraft.tall_dry_grass": "Hosszú száraz fű",
  "block.minecraft.tall_grass": "Magas fű",
  "block.minecraft.tall_seagrass": "Magas tengerifű",
  "block.minecraft.target": "Céltábla",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Tesztblokk",
  "block.minecraft.test_instance_block": "Tesztpéldány-blokk",
  "block.minecraft.tinted_glass": "Sötétített üveg",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "A TNT-robbanások ki vannak kapcsolva",
  "block.minecraft.torch": "Fáklya",
  "block.minecraft.torchflower": "Fáklyaliliom",
  "block.minecraft.torchflower_crop": "Fáklyaliliom-ültetvény",
  "block.minecraft.trapped_chest": "Csapdaláda",
  "block.minecraft.trial_spawner": "Küzdőtéri idézőketrec",
  "block.minecraft.tripwire": "Botlódrót",
  "block.minecraft.tripwire_hook": "Botlódrót-horog",
  "block.minecraft.tube_coral": "Csőkorall",
  "block.minecraft.tube_coral_block": "Csőkorall-blokk",
  "block.minecraft.tube_coral_fan": "Csőkorall-legyező",
  "block.minecraft.tube_coral_wall_fan": "Fali csőkorall-legyező",
  "block.minecraft.tuff": "Tufa",
  "block.minecraft.tuff_brick_slab": "Tufatégla-lap",
  "block.minecraft.tuff_brick_stairs": "Tufatégla-lépcső",
  "block.minecraft.tuff_brick_wall": "Tufatégla fal",
  "block.minecraft.tuff_bricks": "Tufatégla",
  "block.minecraft.tuff_slab": "Tufalap",
  "block.minecraft.tuff_stairs": "Tufalépcső",
  "block.minecraft.tuff_wall": "Tufafal",
  "block.minecraft.turtle_egg": "Teknőstojás",
  "block.minecraft.twisting_vines": "Tekergő indák",
  "block.minecraft.twisting_vines_plant": "Tekergő indaszár",
  "block.minecraft.vault": "Széf",
  "block.minecraft.verdant_froglight": "Zöld varangyfény",
  "block.minecraft.vine": "Inda",
  "block.minecraft.void_air": "Űrbéli levegő",
  "block.minecraft.wall_torch": "Fali fáklya",
  "block.minecraft.warped_button": "Torz gomb",
  "block.minecraft.warped_door": "Torz ajtó",
  "block.minecraft.warped_fence": "Torz kerítés",
  "block.minecraft.warped_fence_gate": "Torz kerítéskapu",
  "block.minecraft.warped_fungus": "Torz gomba",
  "block.minecraft.warped_hanging_sign": "Torz függőtábla",
  "block.minecraft.warped_hyphae": "Torz gombafonalak",
  "block.minecraft.warped_nylium": "Torz nílium",
  "block.minecraft.warped_planks": "Torz deszka",
  "block.minecraft.warped_pressure_plate": "Torz nyomólap",
  "block.minecraft.warped_roots": "Torz gyökerek",
  "block.minecraft.warped_shelf": "Torz polc",
  "block.minecraft.warped_sign": "Torz tábla",
  "block.minecraft.warped_slab": "Torz deszkalap",
  "block.minecraft.warped_stairs": "Torz lépcső",
  "block.minecraft.warped_stem": "Torz tönk",
  "block.minecraft.warped_trapdoor": "Torz csapóajtó",
  "block.minecraft.warped_wall_hanging_sign": "Torz fali függőtábla",
  "block.minecraft.warped_wall_sign": "Torz falitábla",
  "block.minecraft.warped_wart_block": "Torz bibircsókblokk",
  "block.minecraft.water": "Víz",
  "block.minecraft.water_cauldron": "Vízzel teli üst",
  "block.minecraft.waxed_chiseled_copper": "Viaszolt vésett rézblokk",
  "block.minecraft.waxed_copper_bars": "Viaszolt rézrács",
  "block.minecraft.waxed_copper_block": "Viaszolt rézblokk",
  "block.minecraft.waxed_copper_bulb": "Viaszolt rézizzó",
  "block.minecraft.waxed_copper_chain": "Viaszolt rézlánc",
  "block.minecraft.waxed_copper_chest": "Viaszolt rézláda",
  "block.minecraft.waxed_copper_door": "Viaszolt rézajtó",
  "block.minecraft.waxed_copper_golem_statue": "Viaszolt rézgólem-szobor",
  "block.minecraft.waxed_copper_grate": "Viaszolt rézrostély",
  "block.minecraft.waxed_copper_lantern": "Viaszolt rézlámpás",
  "block.minecraft.waxed_copper_trapdoor": "Viaszolt réz csapóajtó",
  "block.minecraft.waxed_cut_copper": "Viaszolt vágott rézblokk",
  "block.minecraft.waxed_cut_copper_slab": "Viaszolt vágott rézlap",
  "block.minecraft.waxed_cut_copper_stairs": "Viaszolt vágott rézlépcső",
  "block.minecraft.waxed_exposed_chiseled_copper": "Viaszolt, megviselt vésett rézblokk",
  "block.minecraft.waxed_exposed_copper": "Viaszolt megviselt rézblokk",
  "block.minecraft.waxed_exposed_copper_bars": "Viaszolt megviselt rézrács",
  "block.minecraft.waxed_exposed_copper_bulb": "Viaszolt megviselt rézizzó",
  "block.minecraft.waxed_exposed_copper_chain": "Viaszolt megviselt rézlánc",
  "block.minecraft.waxed_exposed_copper_chest": "Viaszolt megviselt rézláda",
  "block.minecraft.waxed_exposed_copper_door": "Viaszolt megviselt rézajtó",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Viaszolt megviselt rézgólem-szobor",
  "block.minecraft.waxed_exposed_copper_grate": "Viaszolt megviselt rézrostély",
  "block.minecraft.waxed_exposed_copper_lantern": "Viaszolt megviselt rézlámpás",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Viaszolt, megviselt réz csapóajtó",
  "block.minecraft.waxed_exposed_cut_copper": "Viaszolt, megviselt vágott rézblokk",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Viaszolt, megviselt vágott rézlap",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Viaszolt, megviselt vágott rézlépcső",
  "block.minecraft.waxed_exposed_lightning_rod": "Viaszolt megviselt villámhárító",
  "block.minecraft.waxed_lightning_rod": "Viaszolt villámhárító",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Viaszolt, patinás vésett rézblokk",
  "block.minecraft.waxed_oxidized_copper": "Viaszolt patinás rézblokk",
  "block.minecraft.waxed_oxidized_copper_bars": "Viaszolt patinás rézrács",
  "block.minecraft.waxed_oxidized_copper_bulb": "Viaszolt patinás rézizzó",
  "block.minecraft.waxed_oxidized_copper_chain": "Viaszolt patinás rézlánc",
  "block.minecraft.waxed_oxidized_copper_chest": "Viaszolt patinás rézláda",
  "block.minecraft.waxed_oxidized_copper_door": "Viaszolt patinás rézajtó",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Viaszolt patinás rézgólem-szobor",
  "block.minecraft.waxed_oxidized_copper_grate": "Viaszolt patinás rézrostély",
  "block.minecraft.waxed_oxidized_copper_lantern": "Viaszolt patinás rézlámpás",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Viaszolt, patinás réz csapóajtó",
  "block.minecraft.waxed_oxidized_cut_copper": "Viaszolt, patinás vágott rézblokk",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Viaszolt, patinás vágott rézlap",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Viaszolt, patinás vágott rézlépcső",
  "block.minecraft.waxed_oxidized_lightning_rod": "Viaszolt patinás villámhárító",
  "block.minecraft.waxed_weathered_chiseled_copper": "Viaszolt, viharvert vésett rézblokk",
  "block.minecraft.waxed_weathered_copper": "Viaszolt viharvert rézblokk",
  "block.minecraft.waxed_weathered_copper_bars": "Viaszolt viharvert rézrács",
  "block.minecraft.waxed_weathered_copper_bulb": "Viaszolt viharvert rézizzó",
  "block.minecraft.waxed_weathered_copper_chain": "Viaszolt viharvert rézlánc",
  "block.minecraft.waxed_weathered_copper_chest": "Viaszolt viharvert rézláda",
  "block.minecraft.waxed_weathered_copper_door": "Viaszolt viharvert rézajtó",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Viaszolt viharvert rézgólem-szobor",
  "block.minecraft.waxed_weathered_copper_grate": "Viaszolt viharvert rézrostély",
  "block.minecraft.waxed_weathered_copper_lantern": "Viaszolt viharvert rézlámpás",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Viaszolt, viharvert réz csapóajtó",
  "block.minecraft.waxed_weathered_cut_copper": "Viaszolt, viharvert vágott rézblokk",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Viaszolt, viharvert vágott rézlap",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Viaszolt, viharvert vágott rézlépcső",
  "block.minecraft.waxed_weathered_lightning_rod": "Viaszolt viharvert villámhárító",
  "block.minecraft.weathered_chiseled_copper": "Viharvert vésett rézblokk",
  "block.minecraft.weathered_copper": "Viharvert rézblokk",
  "block.minecraft.weathered_copper_bars": "Viharvert rézrács",
  "block.minecraft.weathered_copper_bulb": "Viharvert rézizzó",
  "block.minecraft.weathered_copper_chain": "Viharvert rézlánc",
  "block.minecraft.weathered_copper_chest": "Viharvert rézláda",
  "block.minecraft.weathered_copper_door": "Viharvert rézajtó",
  "block.minecraft.weathered_copper_golem_statue": "Viharvert rézgólem-szobor",
  "block.minecraft.weathered_copper_grate": "Viharvert rézrostély",
  "block.minecraft.weathered_copper_lantern": "Viharvert rézlámpás",
  "block.minecraft.weathered_copper_trapdoor": "Viharvert réz csapóajtó",
  "block.minecraft.weathered_cut_copper": "Viharvert vágott rézblokk",
  "block.minecraft.weathered_cut_copper_slab": "Viharvert vágott rézlap",
  "block.minecraft.weathered_cut_copper_stairs": "Viharvert vágott rézlépcső",
  "block.minecraft.weathered_lightning_rod": "Viharvert villámhárító",
  "block.minecraft.weeping_vines": "Keserves indák",
  "block.minecraft.weeping_vines_plant": "Keserves indaszár",
  "block.minecraft.wet_sponge": "Nedves szivacs",
  "block.minecraft.wheat": "Búzatermés",
  "block.minecraft.white_banner": "Fehér zászló",
  "block.minecraft.white_bed": "Fehér ágy",
  "block.minecraft.white_candle": "Fehér gyertya",
  "block.minecraft.white_candle_cake": "Torta fehér gyertyával",
  "block.minecraft.white_carpet": "Fehér szőnyeg",
  "block.minecraft.white_concrete": "Fehér beton",
  "block.minecraft.white_concrete_powder": "Fehér szárazbeton",
  "block.minecraft.white_glazed_terracotta": "Fehér mázas kerámia",
  "block.minecraft.white_shulker_box": "Fehér shulkerdoboz",
  "block.minecraft.white_stained_glass": "Fehér festett üveg",
  "block.minecraft.white_stained_glass_pane": "Fehér festett üveglap",
  "block.minecraft.white_terracotta": "Fehér terrakotta",
  "block.minecraft.white_tulip": "Fehér tulipán",
  "block.minecraft.white_wool": "Fehér gyapjú",
  "block.minecraft.wildflowers": "Vadvirágok",
  "block.minecraft.wither_rose": "Witherrózsa",
  "block.minecraft.wither_skeleton_skull": "Withercsontváz-koponya",
  "block.minecraft.wither_skeleton_wall_skull": "Fali withercsontváz-koponya",
  "block.minecraft.yellow_banner": "Sárga zászló",
  "block.minecraft.yellow_bed": "Sárga ágy",
  "block.minecraft.yellow_candle": "Sárga gyertya",
  "block.minecraft.yellow_candle_cake": "Torta sárga gyertyával",
  "block.minecraft.yellow_carpet": "Sárga szőnyeg",
  "block.minecraft.yellow_concrete": "Sárga beton",
  "block.minecraft.yellow_concrete_powder": "Sárga szárazbeton",
  "block.minecraft.yellow_glazed_terracotta": "Sárga mázas kerámia",
  "block.minecraft.yellow_shulker_box": "Sárga shulkerdoboz",
  "block.minecraft.yellow_stained_glass": "Sárga festett üveg",
  "block.minecraft.yellow_stained_glass_pane": "Sárga festett üveglap",
  "block.minecraft.yellow_terracotta": "Sárga terrakotta",
  "block.minecraft.yellow_wool": "Sárga gyapjú",
  "block.minecraft.zombie_head": "Zombifej",
  "block.minecraft.zombie_wall_head": "Fali zombifej",
  "item.minecraft.acacia_boat": "Akáciafa csónak",
  "item.minecraft.acacia_chest_boat": "Akáciafa csónak ládával",
  "item.minecraft.allay_spawn_egg": "Nyugtancsidéző tojás",
  "item.minecraft.amethyst_shard": "Ametisztszilánk",
  "item.minecraft.angler_pottery_shard": "Cserépszilánk horgászbottal",
  "item.minecraft.angler_pottery_sherd": "Horgász cseréptöredék",
  "item.minecraft.apple": "Alma",
  "item.minecraft.archer_pottery_shard": "Cserépszilánk íjjal",
  "item.minecraft.archer_pottery_sherd": "Íjász cseréptöredék",
  "item.minecraft.armadillo_scute": "Tatu-szarulemez",
  "item.minecraft.armadillo_spawn_egg": "Tatuidéző tojás",
  "item.minecraft.armor_stand": "Páncélállvány",
  "item.minecraft.arms_up_pottery_shard": "Cserépszilánk feltartott karokkal",
  "item.minecraft.arms_up_pottery_sherd": "Felemelt kezek cseréptöredék",
  "item.minecraft.arrow": "Nyílvessző",
  "item.minecraft.axolotl_bucket": "Axolotl vödörben",
  "item.minecraft.axolotl_spawn_egg": "Axolotlidéző tojás",
  "item.minecraft.baked_potato": "Sült burgonya",
  "item.minecraft.bamboo_chest_raft": "Bambusztutaj ládával",
  "item.minecraft.bamboo_raft": "Bambusztutaj",
  "item.minecraft.bat_spawn_egg": "Denevéridéző tojás",
  "item.minecraft.bee_spawn_egg": "Méhidéző tojás",
  "item.minecraft.beef": "Nyers marhahús",
  "item.minecraft.beetroot": "Cékla",
  "item.minecraft.beetroot_seeds": "Céklamag",
  "item.minecraft.beetroot_soup": "Céklaleves",
  "item.minecraft.birch_boat": "Nyírfa csónak",
  "item.minecraft.birch_chest_boat": "Nyírfa csónak ládával",
  "item.minecraft.black_bundle": "Fekete Batyu",
  "item.minecraft.black_dye": "Fekete festék",
  "item.minecraft.black_harness": "Fekete hám",
  "item.minecraft.blade_pottery_shard": "Cserépszilánk pengével",
  "item.minecraft.blade_pottery_sherd": "Penge cseréptöredék",
  "item.minecraft.blaze_powder": "Őrlángpor",
  "item.minecraft.blaze_rod": "Lángrúd",
  "item.minecraft.blaze_spawn_egg": "Őrlángidéző tojás",
  "item.minecraft.blue_bundle": "Kék Batyu",
  "item.minecraft.blue_dye": "Kék festék",
  "item.minecraft.blue_egg": "Kék tojás",
  "item.minecraft.blue_harness": "Kék hám",
  "item.minecraft.bogged_spawn_egg": "Láplövészidéző tojás",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Szegecselt páncéldísz",
  "item.minecraft.bone": "Csont",
  "item.minecraft.bone_meal": "Csontliszt",
  "item.minecraft.book": "Könyv",
  "item.minecraft.bordure_indented_banner_pattern": "Csipkézett szegélyű zászlóminta",
  "item.minecraft.bow": "Íj",
  "item.minecraft.bowl": "Tál",
  "item.minecraft.bread": "Kenyér",
  "item.minecraft.breeze_rod": "Szélrúd",
  "item.minecraft.breeze_spawn_egg": "Őrszélidéző tojás",
  "item.minecraft.brewer_pottery_shard": "Cserépszilánk lombikkal",
  "item.minecraft.brewer_pottery_sherd": "Italfőző cseréptöredék",
  "item.minecraft.brewing_stand": "Főzőállvány",
  "item.minecraft.brick": "Tégla",
  "item.minecraft.brown_bundle": "Barna Batyu",
  "item.minecraft.brown_dye": "Barna festék",
  "item.minecraft.brown_egg": "Barna tojás",
  "item.minecraft.brown_harness": "Barna hám",
  "item.minecraft.brush": "Ecset",
  "item.minecraft.bucket": "Vödör",
  "item.minecraft.bundle": "Batyu",
  "item.minecraft.bundle.empty": "Üres",
  "item.minecraft.bundle.empty.description": "Képes egy vegyes összetételű halmot tárolni",
  "item.minecraft.bundle.full": "Megtelt",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Cserépszilánk lánggal",
  "item.minecraft.burn_pottery_sherd": "Láng cseréptöredék",
  "item.minecraft.camel_husk_spawn_egg": "Élőhalott tevét idéző tojás",
  "item.minecraft.camel_spawn_egg": "Teveidéző tojás",
  "item.minecraft.carrot": "Sárgarépa",
  "item.minecraft.carrot_on_a_stick": "Répa horgászboton",
  "item.minecraft.cat_spawn_egg": "Macskaidéző tojás",
  "item.minecraft.cauldron": "Üst",
  "item.minecraft.cave_spider_spawn_egg": "Barlangi pókot idéző tojás",
  "item.minecraft.chainmail_boots": "Láncbakancs",
  "item.minecraft.chainmail_chestplate": "Láncmellvért",
  "item.minecraft.chainmail_helmet": "Láncsisak",
  "item.minecraft.chainmail_leggings": "Lánc lábszárvédő",
  "item.minecraft.charcoal": "Faszén",
  "item.minecraft.cherry_boat": "Cseresznyefa csónak",
  "item.minecraft.cherry_chest_boat": "Cseresznyefa csónak ládával",
  "item.minecraft.chest_minecart": "Tárolócsille",
  "item.minecraft.chicken": "Nyers csirkehús",
  "item.minecraft.chicken_spawn_egg": "Csirkeidéző tojás",
  "item.minecraft.chorus_fruit": "Refréngyümölcs",
  "item.minecraft.clay_ball": "Agyaggolyó",
  "item.minecraft.clock": "Óra",
  "item.minecraft.coal": "Szén",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Tengerparti páncéldísz",
  "item.minecraft.cocoa_beans": "Kakaóbab",
  "item.minecraft.cod": "Nyers tőkehal",
  "item.minecraft.cod_bucket": "Tőkehal vödörben",
  "item.minecraft.cod_spawn_egg": "Tőkehalidéző tojás",
  "item.minecraft.command_block_minecart": "Parancsblokk-csille",
  "item.minecraft.compass": "Iránytű",
  "item.minecraft.cooked_beef": "Sült marhahús",
  "item.minecraft.cooked_chicken": "Sült csirke",
  "item.minecraft.cooked_cod": "Sült tőkehal",
  "item.minecraft.cooked_mutton": "Sült birkahús",
  "item.minecraft.cooked_porkchop": "Sült sertésszelet",
  "item.minecraft.cooked_rabbit": "Sült nyúlhús",
  "item.minecraft.cooked_salmon": "Sült lazac",
  "item.minecraft.cookie": "Csokis süti",
  "item.minecraft.copper_axe": "Rézfejsze",
  "item.minecraft.copper_boots": "Rézcsizma",
  "item.minecraft.copper_chestplate": "Réz mellvért",
  "item.minecraft.copper_golem_spawn_egg": "Rézgólemidéző tojás",
  "item.minecraft.copper_helmet": "Rézsisak",
  "item.minecraft.copper_hoe": "Rézkapa",
  "item.minecraft.copper_horse_armor": "Réz lópáncél",
  "item.minecraft.copper_ingot": "Rézrúd",
  "item.minecraft.copper_leggings": "Réz lábszárvédő",
  "item.minecraft.copper_nautilus_armor": "Réz nautiluszpáncél",
  "item.minecraft.copper_nugget": "Rézrög",
  "item.minecraft.copper_pickaxe": "Rézcsákány",
  "item.minecraft.copper_shovel": "Rézásó",
  "item.minecraft.copper_spear": "Rézlándzsa",
  "item.minecraft.copper_sword": "Rézkard",
  "item.minecraft.cow_spawn_egg": "Tehénidéző tojás",
  "item.minecraft.creaking_spawn_egg": "Nyikorgóidéző tojás",
  "item.minecraft.creeper_banner_pattern": "Zászlóminta",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper címerkép",
  "item.minecraft.creeper_banner_pattern.new": "Creepertöltés zászlóminta",
  "item.minecraft.creeper_spawn_egg": "Creeperidéző tojás",
  "item.minecraft.crossbow": "Számszeríj",
  "item.minecraft.crossbow.projectile": "Lövedék:",
  "item.minecraft.crossbow.projectile.multiple": "Lövedék: %s %s",
  "item.minecraft.crossbow.projectile.single": "Lövedék: %s",
  "item.minecraft.cyan_bundle": "Türkizkék batyu",
  "item.minecraft.cyan_dye": "Türkizkék festék",
  "item.minecraft.cyan_harness": "Türkizkék hám",
  "item.minecraft.danger_pottery_shard": "Cserépszilánk veszéllyel",
  "item.minecraft.danger_pottery_sherd": "Veszély cseréptöredék",
  "item.minecraft.dark_oak_boat": "Sötéttölgy csónak",
  "item.minecraft.dark_oak_chest_boat": "Sötéttölgy csónak ládával",
  "item.minecraft.debug_stick": "Debugpálca",
  "item.minecraft.debug_stick.empty": "%s nem rendelkezik tulajdonságokkal",
  "item.minecraft.debug_stick.select": "\"%s\" kiválasztva (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" értéke %s",
  "item.minecraft.diamond": "Gyémánt",
  "item.minecraft.diamond_axe": "Gyémántfejsze",
  "item.minecraft.diamond_boots": "Gyémántcsizma",
  "item.minecraft.diamond_chestplate": "Gyémánt mellvért",
  "item.minecraft.diamond_helmet": "Gyémántsisak",
  "item.minecraft.diamond_hoe": "Gyémántkapa",
  "item.minecraft.diamond_horse_armor": "Gyémánt lópáncél",
  "item.minecraft.diamond_leggings": "Gyémánt lábszárvédő",
  "item.minecraft.diamond_nautilus_armor": "Gyémánt nautiluszpáncél",
  "item.minecraft.diamond_pickaxe": "Gyémántcsákány",
  "item.minecraft.diamond_shovel": "Gyémántásó",
  "item.minecraft.diamond_spear": "Gyémántlándzsa",
  "item.minecraft.diamond_sword": "Gyémántkard",
  "item.minecraft.disc_fragment_5": "Hanglemez-szilánk",
  "item.minecraft.disc_fragment_5.desc": "Hanglemez – 5",
  "item.minecraft.dolphin_spawn_egg": "Delfinidéző tojás",
  "item.minecraft.donkey_spawn_egg": "Szamáridéző tojás",
  "item.minecraft.dragon_breath": "Sárkánylehelet",
  "item.minecraft.dried_kelp": "Szárított hínár",
  "item.minecraft.drowned_spawn_egg": "Vízbefúltidéző tojás",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dűne-páncéldísz",
  "item.minecraft.echo_shard": "Visszhangszilánk",
  "item.minecraft.egg": "Tojás",
  "item.minecraft.elder_guardian_spawn_egg": "Vén őrszemet idéző tojás",
  "item.minecraft.elytra": "Kitinszárny",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Varázskönyv",
  "item.minecraft.enchanted_golden_apple": "Bűvös aranyalma",
  "item.minecraft.end_crystal": "Endkristály",
  "item.minecraft.ender_dragon_spawn_egg": "Endersárkány-idéző tojás",
  "item.minecraft.ender_eye": "Ender szeme",
  "item.minecraft.ender_pearl": "Endergyöngy",
  "item.minecraft.enderman_spawn_egg": "Endermanidéző tojás",
  "item.minecraft.endermite_spawn_egg": "Endermite-idéző tojás",
  "item.minecraft.evoker_spawn_egg": "Idézőt idéző tojás",
  "item.minecraft.experience_bottle": "Varázslat palackja",
  "item.minecraft.explorer_pottery_shard": "Cserépszilánk térképpel",
  "item.minecraft.explorer_pottery_sherd": "Felfedező cseréptöredék",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Szemes páncéldísz",
  "item.minecraft.feather": "Toll",
  "item.minecraft.fermented_spider_eye": "Erjesztett pókszem",
  "item.minecraft.field_masoned_banner_pattern": "Falazott zászlóminta",
  "item.minecraft.filled_map": "Térkép",
  "item.minecraft.fire_charge": "Tűzgolyó",
  "item.minecraft.firework_rocket": "Tűzijáték",
  "item.minecraft.firework_rocket.flight": "Repülés hossza:",
  "item.minecraft.firework_rocket.multiple_stars": "%s %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Tűzijátékcsillag",
  "item.minecraft.firework_star.black": "Fekete",
  "item.minecraft.firework_star.blue": "Kék",
  "item.minecraft.firework_star.brown": "Barna",
  "item.minecraft.firework_star.custom_color": "Egyéni",
  "item.minecraft.firework_star.cyan": "Türkizkék",
  "item.minecraft.firework_star.fade_to": "Színátmenet:",
  "item.minecraft.firework_star.flicker": "Villódzás",
  "item.minecraft.firework_star.gray": "Szürke",
  "item.minecraft.firework_star.green": "Zöld",
  "item.minecraft.firework_star.light_blue": "Világoskék",
  "item.minecraft.firework_star.light_gray": "Világosszürke",
  "item.minecraft.firework_star.lime": "Világoszöld",
  "item.minecraft.firework_star.magenta": "Bíbor",
  "item.minecraft.firework_star.orange": "Narancssárga",
  "item.minecraft.firework_star.pink": "Rózsaszín",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Vörös",
  "item.minecraft.firework_star.shape": "Ismeretlen forma",
  "item.minecraft.firework_star.shape.burst": "Szabálytalan alakú",
  "item.minecraft.firework_star.shape.creeper": "Creeperfej alakú",
  "item.minecraft.firework_star.shape.large_ball": "Nagy gömb",
  "item.minecraft.firework_star.shape.small_ball": "Kis gömb",
  "item.minecraft.firework_star.shape.star": "Csillag alakú",
  "item.minecraft.firework_star.trail": "Csóva",
  "item.minecraft.firework_star.white": "Fehér",
  "item.minecraft.firework_star.yellow": "Sárga",
  "item.minecraft.fishing_rod": "Horgászbot",
  "item.minecraft.flint": "Kovakő",
  "item.minecraft.flint_and_steel": "Kovakő és acél",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Örvény-páncéldísz",
  "item.minecraft.flow_banner_pattern": "Zászlóminta",
  "item.minecraft.flow_banner_pattern.desc": "Örvény",
  "item.minecraft.flow_banner_pattern.new": "Légörvény zászlóminta",
  "item.minecraft.flow_pottery_sherd": "Örvény cseréptöredék",
  "item.minecraft.flower_banner_pattern": "Zászlóminta",
  "item.minecraft.flower_banner_pattern.desc": "Virág címerkép",
  "item.minecraft.flower_banner_pattern.new": "Virág címerképes zászlóminta",
  "item.minecraft.flower_pot": "Virágcserép",
  "item.minecraft.fox_spawn_egg": "Rókaidéző tojás",
  "item.minecraft.friend_pottery_shard": "Cserépszilánk baráttal",
  "item.minecraft.friend_pottery_sherd": "Barát cseréptöredék",
  "item.minecraft.frog_spawn_egg": "Békaidéző tojás",
  "item.minecraft.furnace_minecart": "Csille kemencével",
  "item.minecraft.ghast_spawn_egg": "Ghastidéző tojás",
  "item.minecraft.ghast_tear": "Ghastkönny",
  "item.minecraft.glass_bottle": "Üvegpalack",
  "item.minecraft.glistering_melon_slice": "Csillámló dinnyeszelet",
  "item.minecraft.globe_banner_pattern": "Zászlóminta",
  "item.minecraft.globe_banner_pattern.desc": "Földgömb",
  "item.minecraft.globe_banner_pattern.new": "Földgömbös zászlóminta",
  "item.minecraft.glow_berries": "Fényszeder",
  "item.minecraft.glow_ink_sac": "Fénylő tintazsák",
  "item.minecraft.glow_item_frame": "Fénylő eszközkeret",
  "item.minecraft.glow_squid_spawn_egg": "Fénylő tintahalat idéző tojás",
  "item.minecraft.glowstone_dust": "Izzókőpor",
  "item.minecraft.goat_horn": "Kecsketülök",
  "item.minecraft.goat_spawn_egg": "Kecskeidéző tojás",
  "item.minecraft.gold_ingot": "Aranyrúd",
  "item.minecraft.gold_nugget": "Aranyrög",
  "item.minecraft.golden_apple": "Aranyalma",
  "item.minecraft.golden_axe": "Aranyfejsze",
  "item.minecraft.golden_boots": "Aranycsizma",
  "item.minecraft.golden_carrot": "Aranyrépa",
  "item.minecraft.golden_chestplate": "Arany mellvért",
  "item.minecraft.golden_helmet": "Aranysisak",
  "item.minecraft.golden_hoe": "Aranykapa",
  "item.minecraft.golden_horse_armor": "Arany lópáncél",
  "item.minecraft.golden_leggings": "Arany lábszárvédő",
  "item.minecraft.golden_nautilus_armor": "Arany nautiluszpáncél",
  "item.minecraft.golden_pickaxe": "Aranycsákány",
  "item.minecraft.golden_shovel": "Aranyásó",
  "item.minecraft.golden_spear": "Aranylándzsa",
  "item.minecraft.golden_sword": "Aranykard",
  "item.minecraft.gray_bundle": "Szürke batyu",
  "item.minecraft.gray_dye": "Szürke festék",
  "item.minecraft.gray_harness": "Szürke hám",
  "item.minecraft.green_bundle": "Zöld batyu",
  "item.minecraft.green_dye": "Zöld festék",
  "item.minecraft.green_harness": "Zöld hám",
  "item.minecraft.guardian_spawn_egg": "Őrszemidéző tojás",
  "item.minecraft.gunpowder": "Puskapor",
  "item.minecraft.guster_banner_pattern": "Zászlóminta",
  "item.minecraft.guster_banner_pattern.desc": "Széllökő",
  "item.minecraft.guster_banner_pattern.new": "Széllökő zászlóminta",
  "item.minecraft.guster_pottery_sherd": "Széllökő cseréptöredék",
  "item.minecraft.happy_ghast_spawn_egg": "Vidám ghastot idéző tojás",
  "item.minecraft.harness": "Hám",
  "item.minecraft.heart_of_the_sea": "Tenger szíve",
  "item.minecraft.heart_pottery_shard": "Cserépszilánk szívvel",
  "item.minecraft.heart_pottery_sherd": "Szív cseréptöredék",
  "item.minecraft.heartbreak_pottery_shard": "Cserépszilánk törött szívvel",
  "item.minecraft.heartbreak_pottery_sherd": "Összetört szív cseréptöredék",
  "item.minecraft.hoglin_spawn_egg": "Hoglinidéző tojás",
  "item.minecraft.honey_bottle": "Mézespalack",
  "item.minecraft.honeycomb": "Méhsejt",
  "item.minecraft.hopper_minecart": "Tölcséres csille",
  "item.minecraft.horse_spawn_egg": "Lóidéző tojás",
  "item.minecraft.host_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gazda páncéldísz",
  "item.minecraft.howl_pottery_shard": "Cserépszilánk farkassal",
  "item.minecraft.howl_pottery_sherd": "Üvöltés cseréptöredék",
  "item.minecraft.husk_spawn_egg": "Kiszáradt zombit idéző tojás",
  "item.minecraft.ink_sac": "Tintazsák",
  "item.minecraft.iron_axe": "Vasfejsze",
  "item.minecraft.iron_boots": "Vascsizma",
  "item.minecraft.iron_chestplate": "Vas mellvért",
  "item.minecraft.iron_golem_spawn_egg": "Vasgólemidéző tojás",
  "item.minecraft.iron_helmet": "Vassisak",
  "item.minecraft.iron_hoe": "Vaskapa",
  "item.minecraft.iron_horse_armor": "Vas lópáncél",
  "item.minecraft.iron_ingot": "Vasrúd",
  "item.minecraft.iron_leggings": "Vas lábszárvédő",
  "item.minecraft.iron_nautilus_armor": "Vas nautiluszpáncél",
  "item.minecraft.iron_nugget": "Vasrög",
  "item.minecraft.iron_pickaxe": "Vascsákány",
  "item.minecraft.iron_shovel": "Vasásó",
  "item.minecraft.iron_spear": "Vaslándzsa",
  "item.minecraft.iron_sword": "Vaskard",
  "item.minecraft.item_frame": "Eszközkeret",
  "item.minecraft.jungle_boat": "Dzsungelfa csónak",
  "item.minecraft.jungle_chest_boat": "Dzsungelfa csónak ládával",
  "item.minecraft.knowledge_book": "Tudás könyve",
  "item.minecraft.lapis_lazuli": "Lazurit",
  "item.minecraft.lava_bucket": "Lávásvödör",
  "item.minecraft.lead": "Lasszó",
  "item.minecraft.leather": "Bőr",
  "item.minecraft.leather_boots": "Bőrcsizma",
  "item.minecraft.leather_chestplate": "Bőrzubbony",
  "item.minecraft.leather_helmet": "Bőrsisak",
  "item.minecraft.leather_horse_armor": "Bőr lópáncél",
  "item.minecraft.leather_leggings": "Bőrnadrág",
  "item.minecraft.light_blue_bundle": "Világoskék batyu",
  "item.minecraft.light_blue_dye": "Világoskék festék",
  "item.minecraft.light_blue_harness": "Világoskék hám",
  "item.minecraft.light_gray_bundle": "Világosszürke batyu",
  "item.minecraft.light_gray_dye": "Világosszürke festék",
  "item.minecraft.light_gray_harness": "Világosszürke hám",
  "item.minecraft.lime_bundle": "Világoszöld batyu",
  "item.minecraft.lime_dye": "Világoszöld festék",
  "item.minecraft.lime_harness": "Világoszöld hám",
  "item.minecraft.lingering_potion": "Időző bájital",
  "item.minecraft.lingering_potion.effect.awkward": "Ügyetlen időző bájital",
  "item.minecraft.lingering_potion.effect.empty": "Nem főzhető időző bájital",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Tűzállóság időző bájitala",
  "item.minecraft.lingering_potion.effect.harming": "Sebzés időző bájitala",
  "item.minecraft.lingering_potion.effect.healing": "Gyógyítás időző bájitala",
  "item.minecraft.lingering_potion.effect.infested": "Molytenyészet időző bájitala",
  "item.minecraft.lingering_potion.effect.invisibility": "Láthatatlanság időző bájitala",
  "item.minecraft.lingering_potion.effect.leaping": "Szökkenés időző bájitala",
  "item.minecraft.lingering_potion.effect.levitation": "Lebegés időző bájitala",
  "item.minecraft.lingering_potion.effect.luck": "Szerencse időző bájitala",
  "item.minecraft.lingering_potion.effect.mundane": "Átlagos időző bájital",
  "item.minecraft.lingering_potion.effect.night_vision": "Éjjellátás időző bájitala",
  "item.minecraft.lingering_potion.effect.oozing": "Nyálkaképzés időző bájitala",
  "item.minecraft.lingering_potion.effect.poison": "Mérgezés időző bájitala",
  "item.minecraft.lingering_potion.effect.regeneration": "Regeneráció időző bájitala",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lassú zuhanás időző bájitala",
  "item.minecraft.lingering_potion.effect.slowness": "Lomhaság időző bájitala",
  "item.minecraft.lingering_potion.effect.strength": "Erő időző bájitala",
  "item.minecraft.lingering_potion.effect.swiftness": "Fürgeség időző bájitala",
  "item.minecraft.lingering_potion.effect.thick": "Sűrű időző bájital",
  "item.minecraft.lingering_potion.effect.turtle_master": "Teknősmester időző bájitala",
  "item.minecraft.lingering_potion.effect.water": "Időző vizespalack",
  "item.minecraft.lingering_potion.effect.water_breathing": "Víz alatti légzés időző bájitala",
  "item.minecraft.lingering_potion.effect.weakness": "Gyengeség időző bájitala",
  "item.minecraft.lingering_potion.effect.weaving": "Hálószövés időző bájitala",
  "item.minecraft.lingering_potion.effect.wind_charged": "Széllökés időző bájitala",
  "item.minecraft.llama_spawn_egg": "Lámaidéző tojás",
  "item.minecraft.lodestone_compass": "Mágnesezett iránytű",
  "item.minecraft.mace": "Buzogány",
  "item.minecraft.magenta_bundle": "Bíbor batyu",
  "item.minecraft.magenta_dye": "Bíbor festék",
  "item.minecraft.magenta_harness": "Bíbor hám",
  "item.minecraft.magma_cream": "Magmakrém",
  "item.minecraft.magma_cube_spawn_egg": "Magmakocka-idéző tojás",
  "item.minecraft.mangrove_boat": "Mangrovefa csónak",
  "item.minecraft.mangrove_chest_boat": "Mangrovefa csónak ládával",
  "item.minecraft.map": "Üres térkép",
  "item.minecraft.melon_seeds": "Dinnyemag",
  "item.minecraft.melon_slice": "Dinnyeszelet",
  "item.minecraft.milk_bucket": "Tejesvödör",
  "item.minecraft.minecart": "Csille",
  "item.minecraft.miner_pottery_shard": "Cserépszilánk csákánnyal",
  "item.minecraft.miner_pottery_sherd": "Bányász cseréptöredék",
  "item.minecraft.mojang_banner_pattern": "Zászlóminta",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang címerkép",
  "item.minecraft.mojang_banner_pattern.new": "Izé zászlóminta",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomidéző tojás",
  "item.minecraft.mourner_pottery_shard": "Cserépszilánk gyászolóval",
  "item.minecraft.mourner_pottery_sherd": "Gyászoló cseréptöredék",
  "item.minecraft.mule_spawn_egg": "Öszvéridéző tojás",
  "item.minecraft.mushroom_stew": "Gombaragu",
  "item.minecraft.music_disc_11": "Hanglemez",
  "item.minecraft.music_disc_11.desc": "C418 – 11",
  "item.minecraft.music_disc_13": "Hanglemez",
  "item.minecraft.music_disc_13.desc": "C418 – 13",
  "item.minecraft.music_disc_5": "Hanglemez",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Hanglemez",
  "item.minecraft.music_disc_blocks.desc": "C418 – blocks",
  "item.minecraft.music_disc_cat": "Hanglemez",
  "item.minecraft.music_disc_cat.desc": "C418 – cat",
  "item.minecraft.music_disc_chirp": "Hanglemez",
  "item.minecraft.music_disc_chirp.desc": "C418 – chirp",
  "item.minecraft.music_disc_creator": "Hanglemez",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Hanglemez",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (zenedoboz)",
  "item.minecraft.music_disc_far": "Hanglemez",
  "item.minecraft.music_disc_far.desc": "C418 – far",
  "item.minecraft.music_disc_lava_chicken": "Hanglemez",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Láva Csirke",
  "item.minecraft.music_disc_mall": "Hanglemez",
  "item.minecraft.music_disc_mall.desc": "C418 – mall",
  "item.minecraft.music_disc_mellohi": "Hanglemez",
  "item.minecraft.music_disc_mellohi.desc": "C418 – mellohi",
  "item.minecraft.music_disc_otherside": "Hanglemez",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Hanglemez",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine – Pigstep",
  "item.minecraft.music_disc_precipice": "Hanglemez",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Hanglemez",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Hanglemez",
  "item.minecraft.music_disc_stal.desc": "C418 – stal",
  "item.minecraft.music_disc_strad": "Hanglemez",
  "item.minecraft.music_disc_strad.desc": "C418 – strad",
  "item.minecraft.music_disc_tears": "Hanglemez",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Hanglemez",
  "item.minecraft.music_disc_wait.desc": "C418 – wait",
  "item.minecraft.music_disc_ward": "Hanglemez",
  "item.minecraft.music_disc_ward.desc": "C418 – ward",
  "item.minecraft.mutton": "Nyers birkahús",
  "item.minecraft.name_tag": "Cédula",
  "item.minecraft.nautilus_shell": "Nautiluszhéj",
  "item.minecraft.nautilus_spawn_egg": "Nautiluszidéző tojás",
  "item.minecraft.nether_brick": "Nethertégla",
  "item.minecraft.nether_star": "Nethercsillag",
  "item.minecraft.nether_wart": "Netherbibircsók",
  "item.minecraft.netherite_axe": "Netheritfejsze",
  "item.minecraft.netherite_boots": "Netheritcsizma",
  "item.minecraft.netherite_chestplate": "Netherit mellvért",
  "item.minecraft.netherite_helmet": "Netheritsisak",
  "item.minecraft.netherite_hoe": "Netheritkapa",
  "item.minecraft.netherite_horse_armor": "Netherit lópáncél",
  "item.minecraft.netherite_ingot": "Netheritrúd",
  "item.minecraft.netherite_leggings": "Netherit lábszárvédő",
  "item.minecraft.netherite_nautilus_armor": "Netherit nautiluszpáncél",
  "item.minecraft.netherite_pickaxe": "Netheritcsákány",
  "item.minecraft.netherite_scrap": "Netheritdarab",
  "item.minecraft.netherite_shovel": "Netheritásó",
  "item.minecraft.netherite_spear": "Netheritlándzsa",
  "item.minecraft.netherite_sword": "Netheritkard",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovácssablon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritfejlesztés",
  "item.minecraft.oak_boat": "Tölgyfa csónak",
  "item.minecraft.oak_chest_boat": "Tölgyfa csónak ládával",
  "item.minecraft.ocelot_spawn_egg": "Ocelotidéző tojás",
  "item.minecraft.ominous_bottle": "Vészjósló palack",
  "item.minecraft.ominous_trial_key": "Vészjósló kulcs",
  "item.minecraft.orange_bundle": "Narancssárga batyu",
  "item.minecraft.orange_dye": "Narancssárga festék",
  "item.minecraft.orange_harness": "Narancssárga hám",
  "item.minecraft.painting": "Festmény",
  "item.minecraft.pale_oak_boat": "Sápadttölgy csónak",
  "item.minecraft.pale_oak_chest_boat": "Sápadttölgy csónak ládával",
  "item.minecraft.panda_spawn_egg": "Pandaidéző tojás",
  "item.minecraft.paper": "Papír",
  "item.minecraft.parched_spawn_egg": "Perzseltidéző tojás",
  "item.minecraft.parrot_spawn_egg": "Papagájidéző tojás",
  "item.minecraft.phantom_membrane": "Fantommembrán",
  "item.minecraft.phantom_spawn_egg": "Fantomidéző tojás",
  "item.minecraft.pig_spawn_egg": "Malacidéző tojás",
  "item.minecraft.piglin_banner_pattern": "Zászlóminta",
  "item.minecraft.piglin_banner_pattern.desc": "Disznóorr",
  "item.minecraft.piglin_banner_pattern.new": "Malacorr zászlóminta",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin verőlegényt idéző tojás",
  "item.minecraft.piglin_spawn_egg": "Piglinidéző tojás",
  "item.minecraft.pillager_spawn_egg": "Rablóidéző tojás",
  "item.minecraft.pink_bundle": "Rózsaszín batyu",
  "item.minecraft.pink_dye": "Rózsaszín festék",
  "item.minecraft.pink_harness": "Rózsaszín hám",
  "item.minecraft.pitcher_plant": "Kancsókanövény",
  "item.minecraft.pitcher_pod": "Kancsókahüvely",
  "item.minecraft.plenty_pottery_shard": "Cserépszilánk ládával",
  "item.minecraft.plenty_pottery_sherd": "Bőség cseréptöredék",
  "item.minecraft.poisonous_potato": "Mérgező burgonya",
  "item.minecraft.polar_bear_spawn_egg": "Jegesmedve-idéző tojás",
  "item.minecraft.popped_chorus_fruit": "Pattogatott refréngyümölcs",
  "item.minecraft.porkchop": "Nyers disznóhús",
  "item.minecraft.potato": "Burgonya",
  "item.minecraft.potion": "Bájital",
  "item.minecraft.potion.effect.awkward": "Ügyetlen bájital",
  "item.minecraft.potion.effect.empty": "Nem főzhető bájital",
  "item.minecraft.potion.effect.fire_resistance": "Tűzállóság bájitala",
  "item.minecraft.potion.effect.harming": "Sebzés bájitala",
  "item.minecraft.potion.effect.healing": "Gyógyítás bájitala",
  "item.minecraft.potion.effect.infested": "Molytenyészet bájitala",
  "item.minecraft.potion.effect.invisibility": "Láthatatlanság bájitala",
  "item.minecraft.potion.effect.leaping": "Szökkenés bájitala",
  "item.minecraft.potion.effect.levitation": "Lebegés bájitala",
  "item.minecraft.potion.effect.luck": "Szerencse bájitala",
  "item.minecraft.potion.effect.mundane": "Átlagos bájital",
  "item.minecraft.potion.effect.night_vision": "Éjjellátás bájitala",
  "item.minecraft.potion.effect.oozing": "Nyálkaképzés bájitala",
  "item.minecraft.potion.effect.poison": "Mérgező bájital",
  "item.minecraft.potion.effect.regeneration": "Regeneráció bájitala",
  "item.minecraft.potion.effect.slow_falling": "Lassú zuhanás bájitala",
  "item.minecraft.potion.effect.slowness": "Lomhaság bájitala",
  "item.minecraft.potion.effect.strength": "Erő bájitala",
  "item.minecraft.potion.effect.swiftness": "Fürgeség bájitala",
  "item.minecraft.potion.effect.thick": "Sűrű bájital",
  "item.minecraft.potion.effect.turtle_master": "Teknősmester bájitala",
  "item.minecraft.potion.effect.water": "Vizespalack",
  "item.minecraft.potion.effect.water_breathing": "Víz alatti légzés bájitala",
  "item.minecraft.potion.effect.weakness": "Gyengeség bájitala",
  "item.minecraft.potion.effect.weaving": "Hálószövés bájitala",
  "item.minecraft.potion.effect.wind_charged": "Széllökés bájitala",
  "item.minecraft.pottery_shard_archer": "Cserépszilánk íjjal",
  "item.minecraft.pottery_shard_arms_up": "Cserépszilánk feltartott karokkal",
  "item.minecraft.pottery_shard_prize": "Cserépszilánk kinccsel",
  "item.minecraft.pottery_shard_skull": "Cserépszilánk koponyával",
  "item.minecraft.powder_snow_bucket": "Porhavas vödör",
  "item.minecraft.prismarine_crystals": "Prizmarinkristály",
  "item.minecraft.prismarine_shard": "Prizmarinszilánk",
  "item.minecraft.prize_pottery_shard": "Cserépszilánk kinccsel",
  "item.minecraft.prize_pottery_sherd": "Jutalom cseréptöredék",
  "item.minecraft.pufferfish": "Gömbhal",
  "item.minecraft.pufferfish_bucket": "Gömbhal vödörben",
  "item.minecraft.pufferfish_spawn_egg": "Gömbhalidéző tojás",
  "item.minecraft.pumpkin_pie": "Tökpite",
  "item.minecraft.pumpkin_seeds": "Tökmag",
  "item.minecraft.purple_bundle": "Lila batyu",
  "item.minecraft.purple_dye": "Lila festék",
  "item.minecraft.purple_harness": "Lila hám",
  "item.minecraft.quartz": "Netherkvarc",
  "item.minecraft.rabbit": "Nyers nyúlhús",
  "item.minecraft.rabbit_foot": "Nyúlláb",
  "item.minecraft.rabbit_hide": "Nyúlbőr",
  "item.minecraft.rabbit_spawn_egg": "Nyúlidéző tojás",
  "item.minecraft.rabbit_stew": "Nyúlpörkölt",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Felemelő páncéldísz",
  "item.minecraft.ravager_spawn_egg": "Pusztítóidéző tojás",
  "item.minecraft.raw_copper": "Nyersréz",
  "item.minecraft.raw_gold": "Nyersarany",
  "item.minecraft.raw_iron": "Nyersvas",
  "item.minecraft.recovery_compass": "Visszatérés iránytűje",
  "item.minecraft.red_bundle": "Vörös batyu",
  "item.minecraft.red_dye": "Vörös festék",
  "item.minecraft.red_harness": "Vörös hám",
  "item.minecraft.redstone": "Redstone-por",
  "item.minecraft.resin_brick": "Gyantatégla",
  "item.minecraft.resin_clump": "Gyantadarab",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Bordás páncéldísz",
  "item.minecraft.rotten_flesh": "Rohadt hús",
  "item.minecraft.saddle": "Nyereg",
  "item.minecraft.salmon": "Nyers lazac",
  "item.minecraft.salmon_bucket": "Lazac vödörben",
  "item.minecraft.salmon_spawn_egg": "Lazacidéző tojás",
  "item.minecraft.scrape_pottery_sherd": "Kaparás cseréptöredék",
  "item.minecraft.scute": "Szarulemez",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Őrségi páncéldísz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Alakító páncéldísz",
  "item.minecraft.sheaf_pottery_shard": "Cserépszilánk köteggel",
  "item.minecraft.sheaf_pottery_sherd": "Kéve cseréptöredék",
  "item.minecraft.shears": "Metszőolló",
  "item.minecraft.sheep_spawn_egg": "Birkaidéző tojás",
  "item.minecraft.shelter_pottery_shard": "Cserépszilánk menedékkel",
  "item.minecraft.shelter_pottery_sherd": "Menedék cseréptöredék",
  "item.minecraft.shield": "Pajzs",
  "item.minecraft.shield.black": "Fekete pajzs",
  "item.minecraft.shield.blue": "Kék pajzs",
  "item.minecraft.shield.brown": "Barna pajzs",
  "item.minecraft.shield.cyan": "Türkizkék pajzs",
  "item.minecraft.shield.gray": "Szürke pajzs",
  "item.minecraft.shield.green": "Zöld pajzs",
  "item.minecraft.shield.light_blue": "Világoskék pajzs",
  "item.minecraft.shield.light_gray": "Világosszürke pajzs",
  "item.minecraft.shield.lime": "Világoszöld pajzs",
  "item.minecraft.shield.magenta": "Bíbor pajzs",
  "item.minecraft.shield.orange": "Narancssárga pajzs",
  "item.minecraft.shield.pink": "Rózsaszín pajzs",
  "item.minecraft.shield.purple": "Lila pajzs",
  "item.minecraft.shield.red": "Vörös pajzs",
  "item.minecraft.shield.white": "Fehér pajzs",
  "item.minecraft.shield.yellow": "Sárga pajzs",
  "item.minecraft.shulker_shell": "Shulkerhéj",
  "item.minecraft.shulker_spawn_egg": "Shulkeridéző tojás",
  "item.minecraft.sign": "Tábla",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Csöndes páncéldísz",
  "item.minecraft.silverfish_spawn_egg": "Ezüstmolyidéző tojás",
  "item.minecraft.skeleton_horse_spawn_egg": "Csontvázlóidéző tojás",
  "item.minecraft.skeleton_spawn_egg": "Csontvázidéző tojás",
  "item.minecraft.skull_banner_pattern": "Zászlóminta",
  "item.minecraft.skull_banner_pattern.desc": "Koponya címerkép",
  "item.minecraft.skull_banner_pattern.new": "Koponya címerképes zászlóminta",
  "item.minecraft.skull_pottery_shard": "Cserépszilánk koponyával",
  "item.minecraft.skull_pottery_sherd": "Koponya cseréptöredék",
  "item.minecraft.slime_ball": "Nyálkagolyó",
  "item.minecraft.slime_spawn_egg": "Nyálkaidéző tojás",
  "item.minecraft.smithing_template": "Kovácssablon",
  "item.minecraft.smithing_template.applies_to": "Alkalmazható:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Helyezz ide fémrudat vagy kristályt",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Páncélzatra",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Helyezz ide páncélt",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Fémek és kristályok",
  "item.minecraft.smithing_template.ingredients": "Összetevők:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Helyezz ide netheritrudat",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Gyémántfelszerelésre",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Helyezz ide gyémántpáncélt, -fegyvert vagy -eszközt",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritrúd",
  "item.minecraft.smithing_template.upgrade": "Fejlesztés: ",
  "item.minecraft.sniffer_spawn_egg": "Orrontóidéző tojás",
  "item.minecraft.snort_pottery_shard": "Cserépszilánk orrontóval",
  "item.minecraft.snort_pottery_sherd": "Szimat cseréptöredék",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Disznóorros páncéldísz",
  "item.minecraft.snow_golem_spawn_egg": "Hógólemidéző tojás",
  "item.minecraft.snowball": "Hógolyó",
  "item.minecraft.spectral_arrow": "Spektrálnyíl",
  "item.minecraft.spider_eye": "Pókszem",
  "item.minecraft.spider_spawn_egg": "Pókidéző tojás",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Városi páncéldísz",
  "item.minecraft.splash_potion": "Robbanó bájital",
  "item.minecraft.splash_potion.effect.awkward": "Ügyetlen robbanó bájital",
  "item.minecraft.splash_potion.effect.empty": "Nem főzhető robbanó bájital",
  "item.minecraft.splash_potion.effect.fire_resistance": "Tűzállóság robbanó bájitala",
  "item.minecraft.splash_potion.effect.harming": "Sebzés robbanó bájitala",
  "item.minecraft.splash_potion.effect.healing": "Gyógyítás robbanó bájitala",
  "item.minecraft.splash_potion.effect.infested": "Molytenyészet robbanó bájitala",
  "item.minecraft.splash_potion.effect.invisibility": "Láthatatlanság robbanó bájitala",
  "item.minecraft.splash_potion.effect.leaping": "Szökkenés robbanó bájitala",
  "item.minecraft.splash_potion.effect.levitation": "Lebegés robbanó bájitala",
  "item.minecraft.splash_potion.effect.luck": "Szerencse robbanó bájitala",
  "item.minecraft.splash_potion.effect.mundane": "Átlagos robbanó bájital",
  "item.minecraft.splash_potion.effect.night_vision": "Éjjellátás robbanó bájitala",
  "item.minecraft.splash_potion.effect.oozing": "Nyálkaképzés robbanó bájitala",
  "item.minecraft.splash_potion.effect.poison": "Mérgezés robbanó bájitala",
  "item.minecraft.splash_potion.effect.regeneration": "Regeneráció robbanó bájitala",
  "item.minecraft.splash_potion.effect.slow_falling": "Lassú zuhanás robbanó bájitala",
  "item.minecraft.splash_potion.effect.slowness": "Lomhaság robbanó bájitala",
  "item.minecraft.splash_potion.effect.strength": "Erő robbanó bájitala",
  "item.minecraft.splash_potion.effect.swiftness": "Fürgeség robbanó bájitala",
  "item.minecraft.splash_potion.effect.thick": "Sűrű robbanó bájital",
  "item.minecraft.splash_potion.effect.turtle_master": "Teknősmester robbanó bájitala",
  "item.minecraft.splash_potion.effect.water": "Robbanó vizespalack",
  "item.minecraft.splash_potion.effect.water_breathing": "Víz alatti légzés robbanó bájitala",
  "item.minecraft.splash_potion.effect.weakness": "Gyengeség robbanó bájitala",
  "item.minecraft.splash_potion.effect.weaving": "Hálószövés robbanó bájitala",
  "item.minecraft.splash_potion.effect.wind_charged": "Széllökés robbanó bájitala",
  "item.minecraft.spruce_boat": "Fenyőfa csónak",
  "item.minecraft.spruce_chest_boat": "Fenyőfa csónak ládával",
  "item.minecraft.spyglass": "Távcső",
  "item.minecraft.squid_spawn_egg": "Tintahalidéző tojás",
  "item.minecraft.stick": "Bot",
  "item.minecraft.stone_axe": "Kőfejsze",
  "item.minecraft.stone_hoe": "Kőkapa",
  "item.minecraft.stone_pickaxe": "Kőcsákány",
  "item.minecraft.stone_shovel": "Kőásó",
  "item.minecraft.stone_spear": "Kőlándzsa",
  "item.minecraft.stone_sword": "Kőkard",
  "item.minecraft.stray_spawn_egg": "Kóborlóidéző tojás",
  "item.minecraft.strider_spawn_egg": "Álomfutóidéző tojás",
  "item.minecraft.string": "Fonál",
  "item.minecraft.sugar": "Cukor",
  "item.minecraft.suspicious_stew": "Gyanús pörkölt",
  "item.minecraft.sweet_berries": "Édes bogyók",
  "item.minecraft.tadpole_bucket": "Ebihal vödörben",
  "item.minecraft.tadpole_spawn_egg": "Ebihalidéző tojás",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Hullámos páncéldísz",
  "item.minecraft.tipped_arrow": "Varázsnyíl",
  "item.minecraft.tipped_arrow.effect.awkward": "Varázsnyíl",
  "item.minecraft.tipped_arrow.effect.empty": "Nem elkészíthető varázsnyíl",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Tűzállóság nyila",
  "item.minecraft.tipped_arrow.effect.harming": "Sebzés nyila",
  "item.minecraft.tipped_arrow.effect.healing": "Gyógyítás nyila",
  "item.minecraft.tipped_arrow.effect.infested": "Molytenyészet nyila",
  "item.minecraft.tipped_arrow.effect.invisibility": "Láthatatlanság nyila",
  "item.minecraft.tipped_arrow.effect.leaping": "Szökkenés nyila",
  "item.minecraft.tipped_arrow.effect.levitation": "Lebegés nyila",
  "item.minecraft.tipped_arrow.effect.luck": "Szerencse nyila",
  "item.minecraft.tipped_arrow.effect.mundane": "Varázsnyíl",
  "item.minecraft.tipped_arrow.effect.night_vision": "Éjjellátás nyila",
  "item.minecraft.tipped_arrow.effect.oozing": "Nyálkaképzés nyila",
  "item.minecraft.tipped_arrow.effect.poison": "Mérgezett nyíl",
  "item.minecraft.tipped_arrow.effect.regeneration": "Regeneráció nyila",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Lassú zuhanás nyila",
  "item.minecraft.tipped_arrow.effect.slowness": "Lomhaság nyila",
  "item.minecraft.tipped_arrow.effect.strength": "Erő nyila",
  "item.minecraft.tipped_arrow.effect.swiftness": "Fürgeség nyila",
  "item.minecraft.tipped_arrow.effect.thick": "Varázsnyíl",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Teknősmester nyila",
  "item.minecraft.tipped_arrow.effect.water": "Vizes nyíl",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vízlégzés nyila",
  "item.minecraft.tipped_arrow.effect.weakness": "Gyengeség nyila",
  "item.minecraft.tipped_arrow.effect.weaving": "Hálószövés nyila",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Széllökés nyila",
  "item.minecraft.tnt_minecart": "TNT-csille",
  "item.minecraft.torchflower_seeds": "Fáklyaliliommagok",
  "item.minecraft.totem_of_undying": "Életmentés toteme",
  "item.minecraft.trader_llama_spawn_egg": "Kereskedőláma-idéző tojás",
  "item.minecraft.trial_key": "Küzdőtéri kulcs",
  "item.minecraft.trident": "Szigony",
  "item.minecraft.tropical_fish": "Trópusi hal",
  "item.minecraft.tropical_fish_bucket": "Trópusi hal vödörben",
  "item.minecraft.tropical_fish_spawn_egg": "Trópusi halat idéző tojás",
  "item.minecraft.turtle_helmet": "Teknőspáncél",
  "item.minecraft.turtle_scute": "Teknős-szarulemez",
  "item.minecraft.turtle_spawn_egg": "Teknősidéző tojás",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Bosszancs-páncéldísz",
  "item.minecraft.vex_spawn_egg": "Bosszancsidéző tojás",
  "item.minecraft.villager_spawn_egg": "Falusiidéző tojás",
  "item.minecraft.vindicator_spawn_egg": "Bosszúálló-idéző tojás",
  "item.minecraft.wandering_trader_spawn_egg": "Vándorkereskedő-idéző tojás",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Strázsa-páncéldísz",
  "item.minecraft.warden_spawn_egg": "Strázsaidéző tojás",
  "item.minecraft.warped_fungus_on_a_stick": "Torz gomba horgászboton",
  "item.minecraft.water_bucket": "Vizesvödör",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vándor-páncéldísz",
  "item.minecraft.wheat": "Búza",
  "item.minecraft.wheat_seeds": "Búzamag",
  "item.minecraft.white_bundle": "Fehér batyu",
  "item.minecraft.white_dye": "Fehér festék",
  "item.minecraft.white_harness": "Fehér hám",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovácssablon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vad páncéldísz",
  "item.minecraft.wind_charge": "Széllöket",
  "item.minecraft.witch_spawn_egg": "Boszorkányidéző tojás",
  "item.minecraft.wither_skeleton_spawn_egg": "Withercsontváz-idéző tojás",
  "item.minecraft.wither_spawn_egg": "Sorvasztóidéző tojás",
  "item.minecraft.wolf_armor": "Farkaspáncél",
  "item.minecraft.wolf_spawn_egg": "Farkasidéző tojás",
  "item.minecraft.wooden_axe": "Fafejsze",
  "item.minecraft.wooden_hoe": "Fakapa",
  "item.minecraft.wooden_pickaxe": "Facsákány",
  "item.minecraft.wooden_shovel": "Faásó",
  "item.minecraft.wooden_spear": "Falándzsa",
  "item.minecraft.wooden_sword": "Fakard",
  "item.minecraft.writable_book": "Könyv és toll",
  "item.minecraft.written_book": "Befejezett könyv",
  "item.minecraft.yellow_bundle": "Sárga batyu",
  "item.minecraft.yellow_dye": "Sárga festék",
  "item.minecraft.yellow_harness": "Sárga hám",
  "item.minecraft.zoglin_spawn_egg": "Zoglinidéző tojás",
  "item.minecraft.zombie_horse_spawn_egg": "Zombilóidéző tojás",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zautiluszt idéző tojás",
  "item.minecraft.zombie_spawn_egg": "Zombiidéző tojás",
  "item.minecraft.zombie_villager_spawn_egg": "Élőhalott falusit idéző tojás",
  "item.minecraft.zombified_piglin_spawn_egg": "Élőhalott piglint idéző tojás"
}
export const hu_hu = items; 
